import { createIcon } from "@chakra-ui/react";
import chakraTheme from "@theme";

export const OpenSeaIcon = createIcon({
    displayName: "OpenSeaIcon",
    viewBox: "0 0 17 15",
    // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
    path: [
        <path
            key="os1"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.18 10.366a.118.118 0 0 0 .07-.11V9.42a.115.115 0 0 0-.147-.112l-3.91 1.144a.101.101 0 0 0-.055.034 10.51 10.51 0 0 1-.874.868 1.31 1.31 0 0 1-.861.322H8.986v-1.458h1.126c.028 0 .057-.01.077-.031l.147-.133.049-.047c.05-.049.107-.103.175-.171l.03-.032c.044-.043.091-.09.137-.143.059-.057.115-.122.167-.184.09-.096.175-.195.262-.302.064-.07.12-.148.178-.226a4.181 4.181 0 0 0 .26-.348c.02-.029.041-.057.06-.086l.017-.026c.036-.057.074-.115.105-.172a3.76 3.76 0 0 0 .465-1.097c.046-.224.057-.447.036-.668a1.213 1.213 0 0 0-.025-.2v-.01a.71.71 0 0 0-.031-.144 3.241 3.241 0 0 0-.216-.647 3.115 3.115 0 0 0-.103-.232 5.457 5.457 0 0 0-.275-.47c-.02-.034-.043-.068-.066-.103a6.05 6.05 0 0 0-.413-.564l-.09-.11a10.16 10.16 0 0 0-.205-.245 11.21 11.21 0 0 0-.733-.749 11.131 11.131 0 0 0-.696-.615 6.431 6.431 0 0 0-.253-.2l-.026-.013a.396.396 0 0 1-.007-.004l-.152-.041V.944a.752.752 0 0 0-.214-.526A.705.705 0 0 0 8.261.2a.735.735 0 0 0-.728.744v.847l-.075-.02-.205-.058-.185-.054h-.011L5.643 1.27c-.062-.018-.113.052-.082.11l.226.42c.012.03.027.062.043.094l.034.07c.039.076.075.154.11.232.032.07.062.138.101.213l.05.112c.058.131.12.27.179.418.054.125.105.253.152.385.128.333.246.69.352 1.053.033.107.06.208.087.314l.008.03.015.064c.042.17.078.338.106.507l.003.015c.02.11.038.216.048.323.016.128.031.255.036.383.01.114.016.236.016.353 0 .297-.026.583-.088.853-.02.078-.043.161-.07.242-.02.078-.05.158-.079.24l-.018.051-.025.064c-.014.037-.028.074-.044.11a8.67 8.67 0 0 1-.46.931c-.247.44-.494.824-.667 1.074-.025.036-.046.067-.066.099-.054.078.002.187.095.187h1.828v1.458H5.684c-.496 0-.956-.283-1.178-.738a1.283 1.283 0 0 1-.133-.725c.005-.076-.05-.143-.124-.143H.516a.115.115 0 0 0-.116.114v.078c0 2.41 1.923 4.363 4.3 4.363h6.7c1.256 0 1.97-1.156 2.67-2.293.196-.318.39-.634.596-.923.368-.518 1.255-.931 1.515-1.043ZM1.399 8.348l-.054.089a.115.115 0 0 0 .097.177H4.88a.113.113 0 0 0 .095-.05 2.61 2.61 0 0 0 .126-.216c.299-.504.564-1.05.659-1.453.226-.98-.257-2.556-.815-3.822a.115.115 0 0 0-.201-.016L1.398 8.348Z"
            fill="currentColor"
        />,
    ],
});

export const CheckmarkTickIcon = createIcon({
    displayName: "CheckmarkTickIcon",
    viewBox: "0 0 20 20",
    path: [
        <path
            key="c1"
            fill="currentColor"
            d="M14.8,6.6c-0.2-0.2-0.6-0.2-0.8,0l-6.2,6.2l-2.4-2.4c-0.2-0.2-0.6-0.2-0.8,0c-0.1,0.1-0.2,0.3-0.2,0.4
        s0.1,0.3,0.2,0.4l0.2,0.2C5.3,12,7,13.8,7.1,13.8l0.1,0.1c0.2,0.2,0.3,0.3,0.6,0.4h0h0c0,0,0.1,0,0.1,0c0.1-0.1,0.2-0.2,0.4-0.3
        l1.2-1.2c1.8-1.8,5.1-5.2,5.2-5.3C15,7.2,15,6.8,14.8,6.6z"
        />,
    ],
});

export const WWWIcon = createIcon({
    displayName: "wwwIcon",
    viewBox: "0 0 32 25.42",
    path: [
        <path
            key="www1"
            fillRule="evenodd"
            fill="currentColor"
            d="M0 8.09v14.18a3.14 3.14 0 0 0 3.12 3.15h25.76A3.14 3.14 0 0 0 32 22.27V8.09Zm8.67 11.49H5.93L6.19 14l-1.32 5.58H2.16L2.33 12H4.4l-.46 6 1.49-6h2.14l-.29 6 1.34-6h2Zm9.77 0h-2.75L16 14l-1.31 5.57h-2.76L12.1 12h2.06l-.45 6 1.48-6h2.15l-.29 6 1.33-6h2Zm9.76 0h-2.74l.26-5.58-1.31 5.57h-2.72l.18-7.57h2.06l-.46 6L25 12h2.15l-.34 6 1.34-6h2ZM28.88 0H3.12A3.31 3.31 0 0 0 0 3.47v3.46h32V3.47A3.31 3.31 0 0 0 28.88 0ZM4.16 4.62a1.11 1.11 0 0 1-1-1.15 1.11 1.11 0 0 1 1-1.16 1.1 1.1 0 0 1 1 1.16 1.1 1.1 0 0 1-1 1.15Zm3.51 0a1.11 1.11 0 0 1-1-1.15 1.11 1.11 0 0 1 1-1.16 1.1 1.1 0 0 1 1 1.16 1.1 1.1 0 0 1-1 1.15Zm3.52 0a1.1 1.1 0 0 1-1-1.15 1.1 1.1 0 0 1 1-1.16 1.11 1.11 0 0 1 1 1.16 1.11 1.11 0 0 1-1 1.15Z"
        />,
    ],
});

export const XIcon = createIcon({
    displayName: "xIcon",
    viewBox: "0 0 18 18",
    path: [
        <path
            key="1"
            fill="currentColor"
            d="M10.9,8.99l6.7-6.7c0.52-0.54,0.5-1.4-0.04-1.91c-0.52-0.5-1.35-0.5-1.87,0l-6.7,6.7l-6.7-6.7
            c-0.54-0.52-1.4-0.5-1.91,0.04c-0.5,0.52-0.5,1.35,0,1.87l6.7,6.7l-6.7,6.7c-0.52,0.54-0.5,1.4,0.04,1.91c0.52,0.5,1.35,0.5,1.87,0
            l6.7-6.7l6.7,6.7c0.53,0.53,1.39,0.53,1.91,0c0.53-0.53,0.53-1.39,0-1.91L10.9,8.99z"
        />,
    ],
});

export const HotIcon = createIcon({
    displayName: "hotIcon",
    viewBox: "0 0 13 13",
    path: [
        <circle key="hot1" cx="6.5" cy="6.5" r="6.5" fill="url(#a)" />,
        <path
            key="hot2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.762 6.462c.104.48-.024.797-.21.843-.412.101-.912-.512-.447-1.143.758-1.03-.36-2.089-.36-2.089-.13 2.652-2.214 1.765-1.107.37.95-1.197-.54-1.801-.54-1.801-.067 1.32-2.258.432-1.014-1.639-2.973 2.973.235 2.915-.676 4.722-.51 1.01-1.617-.024-1.131-1.085C2.916 5.707 3.5 7.16 3.618 7.345c.352.552.26 1.02-.12 1.093-.32.061-.679-.349-.679-.69-.133 1.494.65 2.717 1.993 3.309l.036.015.105.044.023.008.123.047.036.012.114.038c.05.016.102.03.154.045-.368-.335-.732-.915-.424-1.8 0 0 .395.894 1.148 1.061 0 0 1.176-.93.85-3.126 0 0 .926 1.634.167 3.197 0 0 .902-.217 1.146-.75 0 0-.048.757-.489 1.38a3.81 3.81 0 0 0 .195-.068l.121-.05.058-.024c.053-.024.104-.049.155-.074l.012-.006c.054-.027.107-.055.158-.085l.003-.001c1.687-.966 2.073-3.07 1.259-4.458"
            fill="#fff"
        />,
        <defs key="hot3">
            <linearGradient
                id="a"
                x1="1.028"
                y1="2.055"
                x2="1.028"
                y2="13"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FA9600" />
                <stop offset="1" stopColor="#FF2A00" />
            </linearGradient>
        </defs>,
    ],
});

export const ColdIcon = createIcon({
    displayName: "ColdIcon",
    viewBox: "0 0 20 20",
    path: [
        <circle key="cold1" cx="10" cy="10" r="10" fill="url(#cold)" />,
        <path
            key="cold2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.831 9.636a.583.583 0 0 0-.409-.168l-1.2-.006.547-.593a.556.556 0 0 0-.043-.8.586.586 0 0 0-.42-.144.582.582 0 0 0-.4.187l-1.238 1.342-2.66-.014 1.343-2.238 1.815-.354a.567.567 0 0 0 .455-.666.581.581 0 0 0-.683-.443l-.803.156.606-1.01a.559.559 0 0 0-.208-.774.59.59 0 0 0-.794.203l-.606 1.01-.254-.759a.585.585 0 0 0-.732-.362.564.564 0 0 0-.372.713l.574 1.715-1.343 2.238L8.69 6.617l.593-1.709a.549.549 0 0 0-.03-.432.585.585 0 0 0-1.07.07l-.262.756-.595-1.017a.59.59 0 0 0-.792-.21.559.559 0 0 0-.217.77l.595 1.017-.8-.165a.589.589 0 0 0-.438.08.56.56 0 0 0 .024.963c.054.03.112.052.173.064l1.81.373L8.998 9.43l-2.66-.014-1.222-1.354a.581.581 0 0 0-.398-.191.586.586 0 0 0-.421.14.557.557 0 0 0-.053.798l.54.599-1.2-.007A.577.577 0 0 0 3 9.963c0 .202.11.39.288.492.088.05.188.076.29.077l1.2.006-.547.594a.553.553 0 0 0 .044.799.588.588 0 0 0 .82-.043l1.237-1.342 2.66.014-1.343 2.238-1.815.354a.567.567 0 0 0-.455.666.568.568 0 0 0 .276.377c.123.07.268.094.407.067l.803-.157-.606 1.01a.559.559 0 0 0 .208.774.589.589 0 0 0 .794-.203l.606-1.01.254.758a.567.567 0 0 0 .259.314c.143.081.315.1.473.05a.564.564 0 0 0 .372-.714l-.574-1.715 1.343-2.237 1.317 2.251-.593 1.709a.561.561 0 0 0 .364.717c.304.1.634-.06.736-.355l.263-.756.594 1.017a.574.574 0 0 0 .504.285c.1 0 .2-.025.288-.074a.559.559 0 0 0 .217-.772l-.595-1.016.8.165a.582.582 0 0 0 .69-.437.551.551 0 0 0-.083-.426.576.576 0 0 0-.366-.244l-1.81-.373-1.318-2.252 2.66.014 1.222 1.354a.592.592 0 0 0 .82.052.556.556 0 0 0 .052-.798l-.54-.6 1.2.007c.32.001.582-.25.584-.563a.555.555 0 0 0-.169-.402"
            // fill="#fff"
        />,
        <defs key="cold3">
            <linearGradient
                id="cold"
                x1="1.581"
                y1="3.162"
                x2="1.581"
                y2="20"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#80B4F0" />
                <stop offset="1" stopColor="#AFD7F8" />
            </linearGradient>
        </defs>,
    ],
});

export const VibeRaterIcon = createIcon({
    displayName: "VibeRaterIcon",
    viewBox: "0 0 1921.23 1568.2",
    // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
    path: [
        <path
            key="viberater"
            d="M1571.06,785.26c-0.02-0.05-0.05-0.1-0.08-0.16l-62.24-160.7c-1.02-2.64-3.28-4.61-6.04-5.27l-167.66-39.83v0
		c-0.75-0.18-1.43-0.45-2.06-0.79c-0.35-0.19-0.67-0.4-0.99-0.63l-110.27,127.78c0.18,0.12,0.35,0.24,0.54,0.34
		c0.63,0.33,1.31,0.61,2.06,0.79v0l167.66,39.83c2.76,0.66,5.02,2.63,6.04,5.27l62.24,160.7c0.02,0.06,0.05,0.1,0.08,0.16
		L1571.06,785.26z"
            fill="currentColor"
        />,

        <path
            key="viberater2"
            d="M1398.27,984.89c-0.02-0.05-0.05-0.1-0.08-0.16l-62.24-160.7c-1.02-2.64-3.28-4.61-6.04-5.27l-167.66-39.83v0
		c-0.75-0.18-1.43-0.45-2.06-0.79c-0.35-0.19-0.67-0.4-0.99-0.63L1048.93,905.3c0.18,0.12,0.35,0.24,0.54,0.34
		c0.63,0.33,1.31,0.61,2.06,0.79v0l167.66,39.83c2.76,0.66,5.02,2.63,6.04,5.27l62.24,160.7c0.02,0.06,0.05,0.1,0.08,0.16
		L1398.27,984.89z"
            fill="currentColor"
        />,

        <path
            key="viberater3"
            d="M1225.48,1184.52c-0.02-0.05-0.05-0.1-0.08-0.16l-62.24-160.7c-1.02-2.64-3.28-4.61-6.04-5.27l-167.66-39.83v0
		c-0.75-0.18-1.43-0.45-2.06-0.79c-0.35-0.19-0.67-0.4-0.99-0.63l-98.53,115.8L375.28,505.56L161.03,742.6l730.86,825.6
		l331.83-380.98l-0.45-0.16L1225.48,1184.52z"
            fill="currentColor"
        />,

        <path
            key="viberater4"
            d="M1921.23,541.32c0.01-1.94-0.64-3.92-2.09-5.62l-112.23-130.77c-1.85-2.15-2.52-5.07-1.79-7.81l44.1-166.59
		c1.83-6.9-5.05-12.9-11.64-10.16l-159.06,66.33c-2.62,1.09-5.6,0.82-7.99-0.71l-144.81-93.43c-6-3.87-13.83,0.82-13.26,7.93
		l13.93,171.77c0.23,2.83-0.95,5.58-3.15,7.37l-118.23,96.33l0,0l-6.9,5.62l-8.47,6.9c-2.42,1.97-3.39,4.79-3.14,7.46
		c0.04,0.38,0.1,0.76,0.18,1.14c0.43,1.87,1.47,3.6,3.03,4.84c0.4,0.32,0.84,0.58,1.31,0.83c0.63,0.33,1.31,0.61,2.06,0.79l0,0l0,0
		l167.66,39.83c2.76,0.66,5.02,2.63,6.04,5.27l62.24,160.7c0.32,0.83,0.75,1.57,1.25,2.22c0.25,0.32,0.52,0.62,0.81,0.9
		c0.29,0.28,0.59,0.53,0.91,0.76c2.23,1.6,5.13,2.04,7.72,1.22c1.85-0.59,3.53-1.82,4.7-3.72l74.31-121.91l15.38-25.24
		c0.89-1.46,2.2-2.54,3.7-3.25c0.99-0.47,2.05-0.81,3.18-0.87l172.07-9.53c0.89-0.05,1.73-0.22,2.5-0.5
		C1919.05,548.16,1921.21,544.82,1921.23,541.32z"
            fill="currentColor"
        />,

        <path
            key="viberater5"
            d="M1359.83,116.63l107.97,110.21l-1.83-22.58c-1.24-15.35,4.01-30.62,14.42-41.91
		c10.46-11.34,25.29-17.85,40.69-17.84c10.62,0,20.97,3.06,29.93,8.84l21.93,14.15l-138.6-141.46C1418.14,9.49,1395.56,0,1372.38,0
		H363.9c-24.58,0-48.1,10.48-64.53,28.77L22.25,337.15C-7.28,370-7.43,419.68,21.88,452.72l167.58,188.85l78.68-87.05
		L126.83,395.26l250.39-278.63H1359.83z"
            fill="currentColor"
        />,
    ],
});

export const DiamondIcon = createIcon({
    displayName: "DiamondIcon",
    viewBox: "0 0 40 30",
    path: [
        <path
            key="diamond"
            fill="currentColor"
            d="M19.82 30c-2.55-6.94-5.09-13.88-7.71-21H27.9l-7.69 21ZM0 9a11.58 11.58 0 0 1 1.25-.16h8.2a1.39 1.39 0 0 1 1.5 1q3.15 8.64 6.33 17.27a.65.65 0 0 1-.08.61ZM40 9 22.84 27.71l-.19-.09c.07-.25.11-.51.2-.75l6.21-17a1.28 1.28 0 0 1 1.29-1h8.85A5.69 5.69 0 0 1 40 9ZM20 0l7.05 7.27h-14.2ZM6.57.09H18c-2.22 2.41-4.4 4.41-6.67 6.72L6.41.36ZM22.35.06h10.91l.18.25-4.57 6.06ZM34.92.67 40 7.29H30ZM4.91.76l5 6.49H0Z"
        />,
    ],
});

export const CheckBoxIcon = createIcon({
    displayName: "CheckBoxIcon",
    viewBox: "0 0 63.19 45.95",
    path: [
        <path
            key="path2"
            d="M26.27 39.94a3 3 0 0 1-2-.5L9.19 24.37a2.49 2.49 0 1 1 3.52-3.52l13.06 13.06L58.92.75a2.44 2.44 0 0 1 3.52 0 2.42 2.42 0 0 1 0 3.52L27.27 39.44c.51.5-.5.5-1 .5"
            style={{ fill: "#68bc45" }}
        />,
    ],
});

export const PremintIcon = createIcon({
    displayName: "PremintIcon",
    viewBox: "0 0 19.8 28.1",
    path: [
        <path
            key="premint1"
            d="M9.9 0A9.86 9.86 0 0 0 0 9.9a9.65 9.65 0 0 0 5.3 8.7C2.7 23.2 0 27.9 0 28.1h19.8l-5.3-9.5a9.8 9.8 0 0 0 5.3-8.8A10 10 0 0 0 9.9 0Zm4.5 18.6-4.6-8.1s-2.3 4-4.6 8.1a10.07 10.07 0 0 0 4.6 1.1 9.77 9.77 0 0 0 4.6-1.1Z"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
        />,
    ],
});
export const PremintGradientIcon = createIcon({
    displayName: "PremintGradienIcon",
    viewBox: "0 0 19.8 28.1",
    path: [
        <>
            <defs>
                <linearGradient
                    id="a"
                    x1="35.72"
                    y1="-26.78"
                    x2="35.72"
                    y2="79.4"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#e400ff" />
                    <stop offset="1" stopColor="#ffde00" />
                </linearGradient>
            </defs>
            <path
                key="premint1"
                d="M9.9 0A9.86 9.86 0 0 0 0 9.9a9.65 9.65 0 0 0 5.3 8.7C2.7 23.2 0 27.9 0 28.1h19.8l-5.3-9.5a9.8 9.8 0 0 0 5.3-8.8A10 10 0 0 0 9.9 0Zm4.5 18.6-4.6-8.1s-2.3 4-4.6 8.1a10.07 10.07 0 0 0 4.6 1.1 9.77 9.77 0 0 0 4.6-1.1Z"
                fillRule="evenodd"
                clipRule="evenodd"
                fill="url(#a)"
            />
        </>,
    ],
});

export const CalendarGradientIcon = createIcon({
    displayName: "CalendarGradientIcon",
    viewBox: "0 0 71.44 73.02",
    path: [
        <>
            <defs>
                <linearGradient
                    id="a"
                    x1="35.72"
                    y1="-26.78"
                    x2="35.72"
                    y2="79.4"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#e400ff" />
                    <stop offset="1" stopColor="#ffde00" />
                </linearGradient>
            </defs>
            <g>
                <path
                    d="M56.61 8.22V0h-6.53v7.93H21.44V0h-6.53v8.32H0V73h71.44V8.22Zm9.33 59.16H5.47V29.93h60.47Zm0-43.46H5.41v-9.79h9.47c.07.55 0 1.11 0 1.66v5.89h6.53V14.1h28.67v7.58h6.53v-7.54H66Z"
                    fill="url(#a)"
                />
            </g>
        </>,
    ],
});

export const CalendarWhiteIcon = createIcon({
    displayName: "CalendarWhiteIcon",
    viewBox: "0 0 71.44 73.02",
    path: [
        <g key="cw1">
            <path
                d="M56.61 8.22V0h-6.53v7.93H21.44V0h-6.53v8.32H0V73h71.44V8.22Zm9.33 59.16H5.47V29.93h60.47Zm0-43.46H5.41v-9.79h9.47c.07.55 0 1.11 0 1.66v5.89h6.53V14.1h28.67v7.58h6.53v-7.54H66Z"
                fill="currentColor"
            />
        </g>,
    ],
});

export const RocketIcon = createIcon({
    displayName: "RocketIcon",
    viewBox: "0 0 57.17 57.1",
    path: [
        <>
            <defs>
                <linearGradient
                    id="a"
                    x1="28.58"
                    y1="-7.61"
                    x2="28.58"
                    y2="57.15"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#e400ff" />
                    <stop offset="1" stopColor="#ffde00" />
                </linearGradient>
                <linearGradient id="b" x1="11.43" y1="-7.61" x2="11.43" y2="57.15" />
            </defs>

            <g>
                <path
                    d="M57.17 5.36c-.23 1.35-.37 2.72-.7 4-2.67 10.85-7.71 20.3-16.15 27.76A29.9 29.9 0 0 1 37.89 39a1 1 0 0 0-.45 1c.26 3.79-.37 7.35-2.8 10.42a17.7 17.7 0 0 1-8.8 5.68 34.31 34.31 0 0 1-3.73.9c-1.07.22-1.72-.42-1.6-1.52L21.68 45v-.36c-.66 0-1.34-.11-2-.14a3.06 3.06 0 0 1-2.19-1c-1.12-1.15-2.21-2.33-3.41-3.39a4.33 4.33 0 0 1-1.54-3.51v-1.24l-3.62.39c-2.46.26-4.92.54-7.38.79-1.06.11-1.68-.49-1.5-1.49A22.42 22.42 0 0 1 4.16 25a13.28 13.28 0 0 1 10.77-5.39h.48a5.69 5.69 0 0 0 2.3 0c.63-.3 1-1.15 1.48-1.76A44.91 44.91 0 0 1 33 6.5 54.76 54.76 0 0 1 48.17.63C49.37.37 50.6.21 51.81 0H55c.33.07.66.17 1 .21a1 1 0 0 1 1 1 9 9 0 0 0 .22 1.13ZM44.46 18.59a5.87 5.87 0 1 0-5.85 5.87 5.85 5.85 0 0 0 5.85-5.87Z"
                    fill="url(#a)"
                />
                <path
                    d="M4.71 52.53a34.74 34.74 0 0 1 1.53-9.68 5.64 5.64 0 0 1 4.58-3.77c.23 0 .49.11.74.17a2.74 2.74 0 0 1-.21.72 5.35 5.35 0 0 0-.9 3.91 3.57 3.57 0 0 0 4.17 2.88 21.43 21.43 0 0 0 2.73-1c.19-.07.52-.15.6-.06a.86.86 0 0 1 .18.66c-.38 1.95-1.26 3.63-3.19 4.32a36.91 36.91 0 0 1-5.5 1.39c-1.52.26-3.08.3-4.73.46Z"
                    fill="url(#b)"
                />
            </g>
        </>,
    ],
});

export const WhiteRocketIcon = createIcon({
    displayName: "WhiteRocketIcon",
    viewBox: "0 0 57.17 57.1",
    path: [
        <g key="wri1">
            <path
                d="M57.17 5.36c-.23 1.35-.37 2.72-.7 4-2.67 10.85-7.71 20.3-16.15 27.76A29.9 29.9 0 0 1 37.89 39a1 1 0 0 0-.45 1c.26 3.79-.37 7.35-2.8 10.42a17.7 17.7 0 0 1-8.8 5.68 34.31 34.31 0 0 1-3.73.9c-1.07.22-1.72-.42-1.6-1.52L21.68 45v-.36c-.66 0-1.34-.11-2-.14a3.06 3.06 0 0 1-2.19-1c-1.12-1.15-2.21-2.33-3.41-3.39a4.33 4.33 0 0 1-1.54-3.51v-1.24l-3.62.39c-2.46.26-4.92.54-7.38.79-1.06.11-1.68-.49-1.5-1.49A22.42 22.42 0 0 1 4.16 25a13.28 13.28 0 0 1 10.77-5.39h.48a5.69 5.69 0 0 0 2.3 0c.63-.3 1-1.15 1.48-1.76A44.91 44.91 0 0 1 33 6.5 54.76 54.76 0 0 1 48.17.63C49.37.37 50.6.21 51.81 0H55c.33.07.66.17 1 .21a1 1 0 0 1 1 1 9 9 0 0 0 .22 1.13ZM44.46 18.59a5.87 5.87 0 1 0-5.85 5.87 5.85 5.85 0 0 0 5.85-5.87Z"
                fill="#fff"
            />
            <path
                d="M4.71 52.53a34.74 34.74 0 0 1 1.53-9.68 5.64 5.64 0 0 1 4.58-3.77c.23 0 .49.11.74.17a2.74 2.74 0 0 1-.21.72 5.35 5.35 0 0 0-.9 3.91 3.57 3.57 0 0 0 4.17 2.88 21.43 21.43 0 0 0 2.73-1c.19-.07.52-.15.6-.06a.86.86 0 0 1 .18.66c-.38 1.95-1.26 3.63-3.19 4.32a36.91 36.91 0 0 1-5.5 1.39c-1.52.26-3.08.3-4.73.46Z"
                fill="#fff"
            />
        </g>,
    ],
});

export const MetamaskIcon = createIcon({
    displayName: "MetamaskIcon",
    viewBox: "0 0 64.08 59.39",
    path: [
        <>
            <defs>
                <linearGradient
                    id="a"
                    x1="32.04"
                    y1="-1.7"
                    x2="32.04"
                    y2="60.11"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#e400ff" />
                    <stop offset="1" stopColor="#ffde00" />
                </linearGradient>
            </defs>
            <g>
                <path
                    d="M32.06 59.37c-1.26 0-2.52.06-3.78 0a3.55 3.55 0 0 1-1.68-.54c-2.31-1.61-4.59-3.28-6.86-5a2.33 2.33 0 0 0-2.19-.4c-3.76 1.08-7.55 2.11-11.28 3.15A1.59 1.59 0 0 1 4 55.32C2.86 51.46 1.73 47.6.65 43.72a2.34 2.34 0 0 1 0-1.31c1.18-3.6 2.35-7.19 3.51-10.78a4.52 4.52 0 0 0 .06-3.32 32.38 32.38 0 0 1-1.16-4.83C2.08 19 1.11 14.54.11 10.07a3.51 3.51 0 0 1 .07-2c.74-2.19 1.44-4.4 2.16-6.6C2.8.06 3.52-.3 4.92.23c5.75 2.15 11.5 4.33 17.27 6.46a7.68 7.68 0 0 0 2.56.47h13.92a10.13 10.13 0 0 0 3.82-.68C48 4.41 53.52 2.36 59 .29c1.58-.6 2.25-.28 2.77 1.32.65 2 1.26 4 2 6a5.05 5.05 0 0 1 .14 2.93c-1.28 5.77-2.52 11.54-3.77 17.32a1.37 1.37 0 0 1-.07.29c-.78 1.24-.37 2.43 0 3.67 1.12 3.36 2.17 6.75 3.28 10.12a3.7 3.7 0 0 1 .06 2.28c-1.1 3.66-2.14 7.34-3.21 11a1.65 1.65 0 0 1-2.34 1.31c-3.68-1-7.37-2-11-3.08a2.71 2.71 0 0 0-2.6.51 198.3 198.3 0 0 1-6.73 4.88 3.39 3.39 0 0 1-1.63.47c-1.26.11-2.55.06-3.84.06ZM56.9 27.59c.86 0 1-.38 1.12-.84 1.37-5.33 2.76-10.66 4.12-16a2.05 2.05 0 0 0 0-1.1c-.79-2.25-1.61-4.5-2.44-6.73-.35-.94-.78-1.05-1.62-.48L37.54 16.59c-1 .66-1 1.13 0 1.86 2.34 1.83 4.68 3.67 7 5.49a4.12 4.12 0 0 0 1.33.65c2.69.76 5.38 1.49 8.08 2.22 1.05.29 2.13.56 2.95.78ZM1.84 10.14c0 .23.09.42.14.62l4.08 15.85c.28 1 .49 1.16 1.57.87 3.53-.95 7.05-1.89 10.57-2.87a4.26 4.26 0 0 0 1.46-.73c2.2-1.68 4.37-3.41 6.56-5.12 1.49-1.17 1.49-1.4-.09-2.49L6.12 2.52c-.93-.64-1.37-.51-1.75.53Q3.22 6.17 2.08 9.29c-.08.28-.16.58-.24.85ZM32 53.56h4.16c.82 0 1.12-.31 1-.95-.11-1-.24-2-.4-3a1.83 1.83 0 0 0-1.61-1.43h-6.43a2 2 0 0 0-1.64 1.24c-.13.94-.24 1.89-.31 2.84s.23 1.28 1.23 1.3c1.37.02 2.71 0 4 0Zm-5.17-14.89v-.19c-.51-1.06-1-2.14-1.55-3.17a.9.9 0 0 0-.84-.3 34.68 34.68 0 0 0-3.63 1.63c-.68.37-.52 1.23.22 1.52.33.13.67.22 1 .32 1.17.35 2.34.73 3.53 1 .76.25 1.27-.11 1.27-.81Zm11.6.91c1.46-.46 3.2-.94 4.89-1.56.64-.24.54-1.09-.13-1.42-1.08-.53-2.19-1-3.3-1.48a.84.84 0 0 0-1.18.34c-.49 1-1 1.93-1.38 2.92-.26.62.14 1.19 1.1 1.2Z"
                    fill="url(#a)"
                />
            </g>
        </>,
    ],
});

export const WhiteMetamaskIcon = createIcon({
    displayName: "WhiteMetamaskIcon",
    viewBox: "0 0 64.08 59.39",
    path: [
        <g key="wm1">
            <path
                d="M32.06 59.37c-1.26 0-2.52.06-3.78 0a3.55 3.55 0 0 1-1.68-.54c-2.31-1.61-4.59-3.28-6.86-5a2.33 2.33 0 0 0-2.19-.4c-3.76 1.08-7.55 2.11-11.28 3.15A1.59 1.59 0 0 1 4 55.32C2.86 51.46 1.73 47.6.65 43.72a2.34 2.34 0 0 1 0-1.31c1.18-3.6 2.35-7.19 3.51-10.78a4.52 4.52 0 0 0 .06-3.32 32.38 32.38 0 0 1-1.16-4.83C2.08 19 1.11 14.54.11 10.07a3.51 3.51 0 0 1 .07-2c.74-2.19 1.44-4.4 2.16-6.6C2.8.06 3.52-.3 4.92.23c5.75 2.15 11.5 4.33 17.27 6.46a7.68 7.68 0 0 0 2.56.47h13.92a10.13 10.13 0 0 0 3.82-.68C48 4.41 53.52 2.36 59 .29c1.58-.6 2.25-.28 2.77 1.32.65 2 1.26 4 2 6a5.05 5.05 0 0 1 .14 2.93c-1.28 5.77-2.52 11.54-3.77 17.32a1.37 1.37 0 0 1-.07.29c-.78 1.24-.37 2.43 0 3.67 1.12 3.36 2.17 6.75 3.28 10.12a3.7 3.7 0 0 1 .06 2.28c-1.1 3.66-2.14 7.34-3.21 11a1.65 1.65 0 0 1-2.34 1.31c-3.68-1-7.37-2-11-3.08a2.71 2.71 0 0 0-2.6.51 198.3 198.3 0 0 1-6.73 4.88 3.39 3.39 0 0 1-1.63.47c-1.26.11-2.55.06-3.84.06ZM56.9 27.59c.86 0 1-.38 1.12-.84 1.37-5.33 2.76-10.66 4.12-16a2.05 2.05 0 0 0 0-1.1c-.79-2.25-1.61-4.5-2.44-6.73-.35-.94-.78-1.05-1.62-.48L37.54 16.59c-1 .66-1 1.13 0 1.86 2.34 1.83 4.68 3.67 7 5.49a4.12 4.12 0 0 0 1.33.65c2.69.76 5.38 1.49 8.08 2.22 1.05.29 2.13.56 2.95.78ZM1.84 10.14c0 .23.09.42.14.62l4.08 15.85c.28 1 .49 1.16 1.57.87 3.53-.95 7.05-1.89 10.57-2.87a4.26 4.26 0 0 0 1.46-.73c2.2-1.68 4.37-3.41 6.56-5.12 1.49-1.17 1.49-1.4-.09-2.49L6.12 2.52c-.93-.64-1.37-.51-1.75.53Q3.22 6.17 2.08 9.29c-.08.28-.16.58-.24.85ZM32 53.56h4.16c.82 0 1.12-.31 1-.95-.11-1-.24-2-.4-3a1.83 1.83 0 0 0-1.61-1.43h-6.43a2 2 0 0 0-1.64 1.24c-.13.94-.24 1.89-.31 2.84s.23 1.28 1.23 1.3c1.37.02 2.71 0 4 0Zm-5.17-14.89v-.19c-.51-1.06-1-2.14-1.55-3.17a.9.9 0 0 0-.84-.3 34.68 34.68 0 0 0-3.63 1.63c-.68.37-.52 1.23.22 1.52.33.13.67.22 1 .32 1.17.35 2.34.73 3.53 1 .76.25 1.27-.11 1.27-.81Zm11.6.91c1.46-.46 3.2-.94 4.89-1.56.64-.24.54-1.09-.13-1.42-1.08-.53-2.19-1-3.3-1.48a.84.84 0 0 0-1.18.34c-.49 1-1 1.93-1.38 2.92-.26.62.14 1.19 1.1 1.2Z"
                fill="#fff"
            />
        </g>,
    ],
});

export const ETHIcon = createIcon({
    displayName: "ETHIcon",
    viewBox: "0 0 21.08 34.39",
    path: [
        <g key="eth1">
            <path
                fill="currentColor"
                d="m20.8 17.37.28.11a1 1 0 0 0-.08-.18Q16 9 11 .77l-.4-.72c0-.06 0-.06-.09 0l-.07.05-2.38 4L.53 16.56l-.53.91v.07l.1.06 9.8 5.8.64.35.14-.06 8.38-5c.65-.38 1.3-.76 1.94-1.15 0 0 .06-.07.08-.1l-.28-.11"
            />
            <path
                fill="currentColor"
                d="m21 19.6-.11.06-4 2.39-6.31 3.72-1.68-1-7.42-4.35L0 19.58a.94.94 0 0 0 .06.15l2.82 4 6.49 9.13 1.06 1.5h.1l.07-.08 9.17-12.93c.41-.58.82-1.17 1.24-1.75Z"
            />
        </g>,
    ],
});

export const FaucetIcon = createIcon({
    displayName: "FaucetIcon",
    viewBox: "0 0 35.86 35.86",
    path: [
        <g key="f1">
            <path
                d="M35.86 32.23a5.39 5.39 0 0 1-.89 2 4.22 4.22 0 0 1-4.79 1.35 4.09 4.09 0 0 1-2.7-4.05 11.41 11.41 0 0 1 .59-2.62c.58-1.79 1.24-3.56 1.86-5.34.05-.15.11-.29.17-.46h-2.65v-3.12a1.06 1.06 0 0 0-1.06-1.07 4.5 4.5 0 0 0-1.56 0c-.45.18-.77.69-1.15 1.05s-.63.79-1 1a3.77 3.77 0 0 1-1.39.05h-7.75a.72.72 0 0 1-.58-.24q-.83-.86-1.68-1.68a.62.62 0 0 0-.35-.18H6.29v1.39a.41.41 0 0 1-.28.45l-3.63 1.81a.45.45 0 0 0-.31.47v2.16H0v-21h2.08v1.77a.89.89 0 0 0 .64 1c1.11.57 2.2 1.16 3.28 1.7a.39.39 0 0 1 .26.43v1.39h4.52a.84.84 0 0 0 .51-.22c.57-.54 1.12-1.12 1.69-1.67a.85.85 0 0 1 .49-.19h1.24V4.2h-2.2c-.08 0-.19.16-.24.27a3.06 3.06 0 0 1-2.86 1.8 3 3 0 0 1-2.82-1.79A3.15 3.15 0 0 1 8.75.07L9 0h1a3.18 3.18 0 0 1 2.36 2c0 .06.1.14.16.14h2.25V0h6.3v2.1h2.18c.09 0 .22-.13.27-.24A3.07 3.07 0 0 1 24.85.42 9 9 0 0 1 25.91 0h.91l.27.07a3.15 3.15 0 0 1 2.16 4.41 3 3 0 0 1-2.85 1.81 3.06 3.06 0 0 1-2.86-1.8c-.06-.11-.16-.27-.24-.27h-2.2v4.19h1.14a.79.79 0 0 1 .67.27c.53.56 1.08 1.1 1.64 1.63a.75.75 0 0 0 .48.2h1.5a9.45 9.45 0 0 1 9 6.88c.17.59.25 1.2.37 1.81v3.92h-2.69c.06.18.12.32.17.46.53 1.5 1.1 3 1.6 4.51.34 1 .59 2.1.88 3.16ZM6.3 16.81h5.38a.9.9 0 0 1 .51.22c.58.55 1.14 1.13 1.72 1.69a.67.67 0 0 0 .42.18h7.18a.67.67 0 0 0 .42-.18c.59-.56 1.15-1.15 1.75-1.72a.73.73 0 0 1 .45-.19h2.2A3.16 3.16 0 0 1 29.55 20v1h4.27c-.07-.84-.08-1.66-.22-2.46a7.27 7.27 0 0 0-6.3-5.85c-1-.1-2.05-.06-3.08-.06a.79.79 0 0 1-.61-.25c-.54-.57-1.1-1.12-1.66-1.66a.78.78 0 0 0-.48-.19h-7.08a.83.83 0 0 0-.51.21c-.55.52-1.09 1-1.61 1.6a.86.86 0 0 1-.7.29H6.3Zm25.32 8.28c-.16.43-.34.86-.48 1.3-.52 1.64-1.06 3.28-1.54 4.93a1.94 1.94 0 0 0 .89 2.09 2 2 0 0 0 2.31 0 2 2 0 0 0 .91-2.11 40.24 40.24 0 0 0-2.09-6.22M2.1 20.36c.69-.35 1.34-.67 2-1 .06 0 .09-.2.09-.3v-8.64c0-.12 0-.3-.1-.34-.64-.34-1.29-.66-2-1ZM19 2.13h-2.11v6.26H19Zm-9.5 0a1.06 1.06 0 0 0-1.06 1 1.07 1.07 0 0 0 1 1.07 1.05 1.05 0 0 0 1.08-1 1.07 1.07 0 0 0-1-1.06m18 1.06a1.05 1.05 0 1 0-1.05 1 1.07 1.07 0 0 0 1.05-1"
                fill="#fff"
            />
        </g>,
    ],
});

export const SandGlassIcon = createIcon({
    displayName: "SandGlassIcon",
    viewBox: "0 0 21.74 32.61",
    path: [
        <g key="sg1">
            <path
                fill="#fff"
                d="M20.66 0c.32.3.77.55.95.92a1.31 1.31 0 0 1-1.26 1.86c-.71 0-.81.27-.82.89a20.6 20.6 0 0 1-.23 3.24 8.64 8.64 0 0 1-2.74 4.67c-.72.68-1.49 1.32-2.21 2-2.1 2-2.1 3.55 0 5.51.58.54 1.19 1.06 1.79 1.59a9.33 9.33 0 0 1 3.4 7.74v.72c-.06.52.11.73.68.73a1.34 1.34 0 0 1 1.5 1.39 1.37 1.37 0 0 1-1.55 1.36H1.61c-1 0-1.6-.53-1.6-1.38s.56-1.34 1.59-1.39l.58-.05v-1.68a9 9 0 0 1 2.88-6.94c.61-.59 1.26-1.13 1.88-1.71a15.06 15.06 0 0 0 1.14-1.12 2.78 2.78 0 0 0 0-4A20.9 20.9 0 0 0 6 12.37 9.7 9.7 0 0 1 2.18 3.8c.06-.67 0-1.1-.88-1a1.18 1.18 0 0 1-1.25-1A1.32 1.32 0 0 1 .64.25L1.07 0ZM3.35 29.84h14.63c.16 0 .43-.29.44-.46a8.89 8.89 0 0 0-3.05-7.85 27.07 27.07 0 0 1-2.59-2.43 3.85 3.85 0 0 1 0-5.49 17.38 17.38 0 0 1 2.16-2 9.12 9.12 0 0 0 3.55-8c0-.62-.22-.75-.8-.75H4.06l-.68.05c-.33 3.3.47 6.11 3 8.28A30.78 30.78 0 0 1 8.8 13.4a4 4 0 0 1 0 5.83c-.33.35-.68.68-1 1-.67.62-1.38 1.22-2 1.86-2.18 2.1-2.68 4.75-2.41 7.74"
            />
            <path
                fill="#fff"
                d="M4.09 6.83h13.54a3.63 3.63 0 0 1-.34 1 29.64 29.64 0 0 1-2 2.7c-.64.72-1.44 1.29-2.15 2a5.41 5.41 0 0 0-2 3.6c0 .17-.19.33-.3.49-.1-.17-.29-.32-.3-.49a5.61 5.61 0 0 0-2.12-3.75c-.94-.87-1.9-1.72-2.79-2.63a6.09 6.09 0 0 1-1.54-2.92M9.89 25c.71-.44 1.4-.52 1.9.05l.9-.34c0 .3.07.6.13 1.07l4.82 3.37a1.11 1.11 0 0 1-.07.16H4a5.34 5.34 0 0 1 .62-.55l4.63-3.22c.23-.16.43-.37.65-.55ZM11.45 18c.17.26.39.46.35.58s-.3.27-.46.41c-.12-.15-.33-.31-.33-.46s.23-.29.44-.53M12 20.74c-.27.18-.44.37-.58.36s-.28-.24-.42-.37c.15-.15.28-.37.46-.41s.29.22.54.42M10.3 21.5c.19.24.41.39.41.53s-.21.31-.34.46c-.15-.14-.39-.26-.44-.43s.19-.31.37-.56"
            />
            <path
                fill="#fff"
                d="M9.91 25c-.37-.05-.67-.18-.49-.63a.51.51 0 0 1 .39-.23c.1 0 .33.15.32.21a4.32 4.32 0 0 1-.23.65M10.38 19.93c-.22-.24-.47-.4-.45-.51s.25-.31.39-.47c.14.13.36.25.39.39s-.17.32-.33.59M11.44 24c-.21-.26-.42-.42-.42-.57s.24-.38.37-.38a.56.56 0 0 1 .41.35c0 .14-.18.32-.36.6"
            />
        </g>,
    ],
});

export const ExternalIcon = createIcon({
    displayName: "ExternalIcon",
    viewBox: "0 0 25.8 25.8",
    path: [
        <g key="ex1">
            <path
                fill="currentColor"
                d="M25.8 10.37v7.48a3 3 0 0 1-3 3h-1.66c-.22 0-.3.08-.3.29v1.67a3 3 0 0 1-2.85 3H3.09A2.88 2.88 0 0 1 .26 24 3.13 3.13 0 0 1 0 22.76V8a3 3 0 0 1 3.08-3h1.6c.21 0 .3-.07.29-.29C5 4.13 5 3.58 5 3a2.94 2.94 0 0 1 2.71-3h14.93a3 3 0 0 1 2.51 1.13 2.81 2.81 0 0 1 .64 1.8v7.43ZM10.45 23.86H17.9a1 1 0 0 0 1-1v-1.63c0-.29-.11-.37-.38-.36h-6.51a1 1 0 0 1-1-1.09 1 1 0 0 1 .99-.89h10.7a1 1 0 0 0 1.12-1.12V3.13A1.05 1.05 0 0 0 22.69 2H8.11a1 1 0 0 0-1.18 1.14v10.32a4.52 4.52 0 0 1 0 .52.94.94 0 0 1-.67.84.86.86 0 0 1-.94-.2 1.09 1.09 0 0 1-.32-.87V7.29c0-.29-.1-.37-.37-.36H3.11a1 1 0 0 0-1.17 1.14v14.58a1.06 1.06 0 0 0 1.19 1.21h7.31"
                transform="translate(0 -.01)"
            />
            <path
                fill="currentColor"
                d="m18.77 8.44-.91.89-4.5 4.5q-3.25 3.26-6.5 6.5l-.21.21a1 1 0 1 1-1.35-1.4c.82-.83 1.65-1.65 2.48-2.47l8.42-8.43 1-1c.06-.06.11-.13.21-.25-.17 0-.28-.05-.38-.05h-3.12a1 1 0 0 1-1-.9 1 1 0 0 1 .95-1h5.87a1 1 0 0 1 1.09 1.08v5.76a1 1 0 0 1-.95 1.07 1 1 0 0 1-1-1.07V8.75a2.45 2.45 0 0 0 0-.27Z"
                transform="translate(0 -.01)"
            />
        </g>,
    ],
});

export const PlusIcon = createIcon({
    displayName: "PlusIcon",
    viewBox: "0 0 41.4 45.58",
    path: [
        <>
            <defs>
                <linearGradient
                    id="a"
                    x1="-625.77"
                    y1="12577.18"
                    x2="-624.77"
                    y2="12577.18"
                    gradientTransform="matrix(0 37.83 37.83 0 -475834.46 23666.62)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#e300ff" />
                    <stop offset="1" stopColor="#fd0" />
                </linearGradient>
            </defs>
            <g>
                <path
                    fill="url(#a)"
                    d="M22.3 0v21.33h19.1v2.92H22.3v21.33h-3.06V24.25H0v-2.92h19.24V0h3.06z"
                />
            </g>
        </>,
    ],
});

export const BRLogoHorizontal = createIcon({
    displayName: "BRLogoHorizontal",
    viewBox: "0 0 1690.94 336.4",
    path: [
        <>
            <defs>
                <linearGradient
                    id="linear-gradient"
                    x1="510.21"
                    y1="3218.08"
                    x2="499.48"
                    y2="3142.96"
                    gradientTransform="rotate(29.5 6310.96 1256.847)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#bb9b48" />
                    <stop offset="1" stopColor="#eabd4e" />
                </linearGradient>
            </defs>
            <g>
                <g>
                    <path
                        d="m314.16 157-12.46-32.14a1.69 1.69 0 0 0-1.21-1l-33.52-8a1.52 1.52 0 0 1-.42-.16 1.22 1.22 0 0 1-.19-.12l-22.05 25.55.1.07a1.92 1.92 0 0 0 .42.16l33.52 8a1.72 1.72 0 0 1 1.21 1.06L292 182.49Z"
                        fill="#f3da9b"
                    />
                    <path
                        d="m279.61 197-12.45-32.14a1.73 1.73 0 0 0-1.21-1.05l-33.53-8a1.46 1.46 0 0 1-.41-.16 2.12 2.12 0 0 1-.2-.12L209.75 181l.11.07a1.84 1.84 0 0 0 .41.16l33.53 8a1.74 1.74 0 0 1 1.21 1.06l12.44 32.13Z"
                        fill="#f9ebc9"
                    />
                    <path
                        fill="#fff"
                        d="M245.06 236.87 232.6 204.7a1.73 1.73 0 0 0-1.21-1l-33.53-8a1.46 1.46 0 0 1-.41-.16 1.32 1.32 0 0 1-.2-.12l-19.7 23.16L75 101.1l-42.8 47.4 146.15 165.09 66.36-76.18h-.09Z"
                    />
                    <path
                        d="M384.19 108.25a1.73 1.73 0 0 0-.42-1.13L361.33 81a1.7 1.7 0 0 1-.36-1.56l8.82-33.31a1.72 1.72 0 0 0-2.33-2l-31.81 13.2a1.7 1.7 0 0 1-1.59-.14l-29-18.68a1.72 1.72 0 0 0-2.65 1.58l2.78 34.35a1.72 1.72 0 0 1-.63 1.48L281 95.18l-1.38 1.12-1.69 1.38a1.69 1.69 0 0 0-.63 1.49 1.57 1.57 0 0 0 0 .23 1.69 1.69 0 0 0 .6 1 1.78 1.78 0 0 0 .27.17 1.66 1.66 0 0 0 .41.15l33.53 8a1.69 1.69 0 0 1 1.2 1l12.45 32.14a1.73 1.73 0 0 0 .25.44.93.93 0 0 0 .16.18 1.19 1.19 0 0 0 .18.15 1.79 1.79 0 0 0 1.55.25 1.75 1.75 0 0 0 .94-.75l14.86-24.38 3.07-5a1.66 1.66 0 0 1 .74-.65 1.75 1.75 0 0 1 .64-.18l34.41-1.9a2.11 2.11 0 0 0 .5-.1 1.75 1.75 0 0 0 1.13-1.67Z"
                        fill="url(#linear-gradient)"
                    />
                    <path
                        fill="#fff"
                        d="m271.92 23.32 21.6 22-.37-4.51a11 11 0 0 1 17-10.18l4.38 2.83-27.7-28.25A17.47 17.47 0 0 0 274.43 0H72.77a17.4 17.4 0 0 0-12.91 5.75L4.45 67.42a17.32 17.32 0 0 0-.07 23.11l33.51 37.76 15.73-17.4L25.36 79l50.07-55.68ZM425.14 90.73h55.44l38.63 123.52 38.14-123.52h53.82l-63.73 171.64H490ZM621 90.73h53.15v171.64H621ZM702.75 90.73H802q24.83 0 38.11 12.29a39.82 39.82 0 0 1 13.29 30.44 38.38 38.38 0 0 1-9.49 26.11q-6.32 7.26-18.49 11.48 18.49 4.44 27.22 15.28t8.72 27.22a46.88 46.88 0 0 1-6.2 24 45.78 45.78 0 0 1-17 16.86q-6.68 3.86-20.14 5.62-17.91 2.34-23.77 2.34h-91.5Zm53.5 67.32h23.07q12.4 0 17.27-4.27c3.23-2.85 4.86-7 4.86-12.35 0-5-1.63-8.9-4.86-11.71s-8.88-4.22-16.92-4.22h-23.42Zm0 67.44h27q13.69 0 19.32-4.86t5.62-13.06a15.14 15.14 0 0 0-5.56-12.23q-5.56-4.62-19.5-4.62h-26.88ZM1662.47 144.84a139.59 139.59 0 0 1-20.29-3.64c-3.67-.95-7.48-2.66-11.29-2.82a33.11 33.11 0 0 0-8.38.21c-7.71 1.57-11.9 7.68-14.94 14.66-.67-4.25 1.48-8.59.7-12.81-1.22-6.59-5.78-10.35-11.89-11.79-.92-.22-8.62-1-9.05.1-2.2 5.77-3.93 14.83-5.3 20.87-6.69 29.46-13.67 60.16-36.6 81.47-12.08 11.23-26.54 22.11-41.6 29-7.7 3.51-15.81 5.88-24.67 6-5 .05-8.56-2.58-10.14-7.53a33.68 33.68 0 0 1-1.08-13.81c1.14-11.52 4.67-22.17 9-32.52a6.92 6.92 0 0 1 .57-.94c.2.14.33.18.39.26.21.3.4.61.59.92 4.26 6.86 10.14 10.25 17.88 9.87a47.69 47.69 0 0 0 19.09-5.2c10.65-5.29 19.3-12.92 26.62-22.06a66.34 66.34 0 0 0 12.17-22.32c5.8-19.23-10.67-39.41-28.75-44.21-18.37-4.87-35.84 5-47.91 18.38-15 16.68-29 33.35-35.82 55.18a13.58 13.58 0 0 1-1.8 4.07C1431 218 1422.25 230 1413 241.6c-5.3 6.65-11.28 12.74-17.2 18.85a23.56 23.56 0 0 1-6.77 4.34c-2.07 1-3.41-.05-3.72-2.48a6.74 6.74 0 0 1 0-1.9c.46-2.73.62-5.61 1.53-8.15 3.46-9.72 6.72-19.57 10.86-28.94A767.62 767.62 0 0 1 1460.15 110a2.43 2.43 0 0 1 2.43-1c10 .22 20.05.51 30.06.59 11.33.1 41-1 52.07-3a46.75 46.75 0 0 0 8.75-2.41c5.54-2.17 8.82-6.3 9.29-12.49a29.21 29.21 0 0 0-1.52-12.6c-3.24-8.72-13.69-11.23-19.4-9.88a5 5 0 0 0-1.48 1 10.47 10.47 0 0 0 1.48 1.68c3.45 2.55 3.56 3.84.42 6.12a10.2 10.2 0 0 1-2.43 1.41c-3 1-24.33 3.59-27.46 4.27-10.93 2.41-22.26 2.88-33.59 3.33-.37 0-.76-.05-1.4-.1.46-.64.76-1.08 1.09-1.5 3-3.77 6-7.59 9.12-11.28a4.17 4.17 0 0 0 .38-5.23 23.67 23.67 0 0 0-2.72-4.07 57.4 57.4 0 0 0-24.86-16.79c-5-1.68-9.19-1.22-12.39 2.68-2.27 2.76-4.88 5.26-6.86 8.22-5.76 8.61-11.28 17.38-16.86 26.11-.54.83-1 1.45-2.22 1.38-4.58-.26-9.16-.44-13.75-.61-15.77-.61-31.58-1.58-47.15-.22-7.1.62-14 1.93-20.31 4.87-7.87 3.66-11.55 10.25-10.47 18.71.58 4.51 3 7.66 7 9.89a24.82 24.82 0 0 0 10.67 3.22 60.08 60.08 0 0 0 9.39-.53c.48-.05.8-1 1.19-1.48a7.41 7.41 0 0 0-1.9-1.11c-.84-.19-1.79.18-2.57-.11a5.09 5.09 0 0 1-2.6-1.82c-.29-.53.36-1.79.94-2.37a6.48 6.48 0 0 1 2.72-1.53 73 73 0 0 1 9.15-2.33c14.95-2.33 30.25-2.51 45.57-2.52a9.56 9.56 0 0 1 1.27.15c-.37.78-.65 1.43-1 2-10.58 20.65-20.41 41.72-29.31 63.28s-19.33 43.57-21.34 67.18c-3 4.88-6.93 9-10.55 13.56-34.63 43.23-30.88 2.13-5-60.82 21-51-15.86-51.69-15.86-51.69s-3.19 6-7.65 15.4c-18.44-17.65-66.44-47.92-101.68 68.92-9.2 30.54 18.81 80.14 65.28 23.49 3.55-4.33 6.77-8.29 9.69-11.92-1.48 12.74-.5 24 4.64 31.66 10.73 15.92 26.35 21.85 42.9 10.79 10.22-6.83 16.47-13.71 19.1-22.51 3 16.13 12.12 32.67 31.06 23.95a62.52 62.52 0 0 0 16.12-11.14c10.32-9.48 19-20.42 27-32 .48-.7 1-1.39 1.67-2.35.34 3.3.57 6.17 1 9 1.17 8.64 3.6 17 9.17 24.34 6.76 8.93 15.4 14.07 26.3 13.89 19.34-.34 37.85-8.72 53.54-19.52a154.39 154.39 0 0 0 19.1-16.1c5.6-5.36 11.88-10.53 17-16.36a198.72 198.72 0 0 1-7.53 25.94c-1.15 3.32-2.34 6.63-3.52 9.94-.8 2.42-1.9 4.8-2.1 7.37a4.82 4.82 0 0 0 2.94 5.14c2.29.78 4.87-.58 7.09-1.11a37.28 37.28 0 0 0 7.27-2.15c4.07-1.92 6.47-5.39 8.26-9.37 10.47-23.27 16.93-48.49 23.43-73.09 2.81-10.64 4.66-22.66 14.15-29.64a20.48 20.48 0 0 1 4.38-2.69c2.88-1 6 0 8.86.72 1.93.46 3.84 1 5.74 1.6 4.24 1.28 8.45 2.69 12.68 4 8.35 2.57 17.22 5.12 26 4.54 8.39-.55 15.27-4.85 19-12.52a22.52 22.52 0 0 0 1.81-11.41c-.14-2-.44-4-.77-5.93-.13-.73-.29-4.18-1.77-3.43-.42.21-.83 1-1.08 1.37a15.94 15.94 0 0 1-2.29 3.28c-1.64 1.49-4.08 1.58-6.3 1.55-5.38-.08-10.79-.39-16.16-.97Zm-167.66 36.07c5.5-7.47 11.88-14.14 19.78-19.18 4.94-3.14 10.24-5.48 16.49-5.63 2.59-.06 3.63 1.09 2.39 3.24a60.58 60.58 0 0 1-6.81 9.88c-8.64 9.75-18.44 18.23-30 24.53-3.36 1.83-7.22 2.86-10.87 4.2a7.44 7.44 0 0 1-1.79.21l-.51-.63c3.76-5.53 7.35-11.23 11.32-16.62Zm-193.25 23.94c-15.2 22.25-38.19 52.41-49 48.81-16.28-5.45 22.23-115.23 62.65-84.46a375.71 375.71 0 0 0-13.65 35.65Z"
                    />
                    <path
                        fill="#fff"
                        d="M1659 53.11c-2-6.56-7.89-9.66-14.08-12.45a191.06 191.06 0 0 0-28.29-9.87 295.92 295.92 0 0 0-58.62-9.39c-34.61-2.29-69.35.57-103.67 5C1395.25 34.16 1335 45.06 1272 63.38c-5.15-16.11-15.78-27.48-31.47-34.63-12.78-5.83-26-8.28-39.47-9.54a268.6 268.6 0 0 0-52.39.63 285.94 285.94 0 0 0-51.51 9.91c-18.85 5.5-36.78 12.76-52.93 23.39-11.86 7.8-22.31 17-29.41 29.55-5.56 9.81-8.23 20.55-6.48 32.53s11.1 19.13 22 22.69c11.63 3.82 24.4 4.37 36.54 4.37a158.81 158.81 0 0 0 19.86-1.28 575.38 575.38 0 0 0-25.2 69.67c-5.87 20.59-13 42.81-5.55 63.88 4.57 12.82 13.77 21.53 27.61 21.76 7.27.11 13.24-2.35 17.7-7.63a11.38 11.38 0 0 0 2-3.77c.44-1.29-.34-2.24-1.75-2.16a16.64 16.64 0 0 0-4 .83c-2.41.74-4.72 1.75-7.17 2.34-3.25.78-5.86-.65-7-4a29.9 29.9 0 0 1-1.61-7.39c-.73-8.66.58-17 2.39-25.13 4.1-18.53 10.91-35.89 18.27-53a1.72 1.72 0 0 1 1.93-1.15c3.07.09 6.14.14 9.19 0a3 3 0 0 1 3 1.52q12.8 18.94 25.7 37.8c13.47 19.78 27.21 39.38 42.67 57.79 9.87 11.74 20.32 22.91 32.76 32 7.09 5.18 14.6 9.36 23 11.2 12.3 2.68 21.19-1.38 25.53-12 3.42-8.32 3.76-17.27 1.82-26.52a30.38 30.38 0 0 0-2.4-6.32 2.86 2.86 0 0 0-3.25-1.7 2.47 2.47 0 0 0-2.16 2.58c0 .79 0 1.61.07 2.42.05 3.23-1.18 4.83-4.24 5.5-4.65 1-9.29.08-13.89-1.69-6.91-2.66-13-6.87-18.83-11.53a234.88 234.88 0 0 1-31.73-31.33c-17.24-20.29-34.1-40.89-51.12-61.36a11.7 11.7 0 0 1-.74-1.15c.55-.17 1-.32 1.38-.42 6.39-1.44 12.87-2.63 19.16-4.34 27.46-7.46 52.49-19.29 74.59-36.26 11.54-8.86 21.69-19.06 29.68-31.35 8.19-12.58 11.94-26.19 10.59-41.09q6.06-1.84 12.14-3.63A1106.51 1106.51 0 0 1 1410.68 47c23.26-4 46.59-7.52 70-10.25 22.47-2.62 45.12-5.17 67.78-4.24a261 261 0 0 1 37.91 4.34c10.34 2 21.39 4.46 30.41 10.39 4.15 2.73 8.88 6.39 9.89 11.53A12.79 12.79 0 0 1 1621 72c-1.54.91-3.57 2-3.31 3.77a3.4 3.4 0 0 0 1.84 2.2c5.57 3.38 12.71 2.47 19 .61 10.16-3 22.6-10.26 21.11-22.65a16.69 16.69 0 0 0-.64-2.82Zm-549.79 39.34c-5.32 10.84-10.47 21.61-15.39 32.41-28 6.63-49.36 5.7-46.27-15.53A37.09 37.09 0 0 1 1052 100c6.2-9.75 14.86-17 24.29-23.44 15.92-10.83 33.58-18.52 52.24-24.34.73-.23 1.47-.4 2.68-.72-.53.93-.83 1.44-1.1 1.95-6.98 12.95-14.38 25.73-20.9 39Zm128.79 8.28c-9.7 13.54-21.88 24.59-35.2 34.46a206.59 206.59 0 0 1-50 27.63c-9.84 3.72-20 6.63-30.81 7.44a4.28 4.28 0 0 1-2.38-.75 22.06 22.06 0 0 1-2.12-2 2 2 0 0 1-.49-2.85q9.07-18 18.76-35.56c18.33-6.15 36.42-13.6 54.28-20.44q5.89-2.26 11.74-4.49 21.6-8.19 43.5-15.53a80.22 80.22 0 0 1-7.28 12.09ZM1250.22 70q-27.13 8.53-55 19.07l-11.8 4.51c-9.76 3.75-22 8.66-35.06 13.62q6.79-11.52 13.92-22.81c5.52-8.7 11.63-17 17.53-25.42 1.06-1.51.75-3 0-4.55-1.94-3.88-5.06-6.8-8.28-9.62l-1.61-1.38c0-.14.09-.29.14-.44 2.1-.17 4.19-.41 6.31-.5 9.7-.42 19.38-1.12 29.13-1.08a73.08 73.08 0 0 1 27.44 5.09c5.67 2.3 10.81 5.44 14.18 10.9a22 22 0 0 1 3.1 12.61ZM932.58 189.66h82.54v-35h-82.54v-27.28h66.48a37.06 37.06 0 0 1-3.12-10.38 60.52 60.52 0 0 1 1.88-26.3H879.43v171.67h144.71V223.5h-91.56Z"
                    />
                </g>
            </g>
        </>,
    ],
});

export const WSMLogoHorizontal = createIcon({
    displayName: "WSMLogoHorizontal",
    viewBox: "0 0 1540.22 299.23",
    path: [
        <>
            <defs>
                <linearGradient
                    id="linear-gradient"
                    x1="220.12"
                    y1="128.64"
                    x2="213.84"
                    y2="84.64"
                    gradientTransform="translate(29.32 -71.95)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#bb9b48" />
                    <stop offset="1" stopColor="#eabd4e" />
                </linearGradient>
            </defs>
            <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                    <path
                        fill="#fff"
                        d="M348.16 86.11H388l14.34 76 21-76H463l21 75.87 14.4-75.87H538l-29.89 135.71H467l-23.8-85.44-23.72 85.44h-41.13ZM618.11 199.42H570.5l-6.62 22.4h-42.82l51-135.71h45.75l51 135.71H624.9Zm-8.7-29.35-15-48.78-14.81 48.78ZM674.56 86.11h41.94V188.4H782v33.42H674.56ZM793.43 86.11h41.94V188.4h65.45v33.42H793.43Z"
                    />
                    <path
                        fill="#fff"
                        d="m866.51 143.5 16.18-1.57q1.45 8.15 5.93 12t12 3.82q8 0 12.11-3.4a10.14 10.14 0 0 0 4.07-7.95 7.53 7.53 0 0 0-1.71-5 13.8 13.8 0 0 0-6-3.56q-2.91-1-13.31-3.6-13.38-3.31-18.77-8.15a21.43 21.43 0 0 1-7.58-16.57A21.15 21.15 0 0 1 873 97.75a22.27 22.27 0 0 1 10.28-8.34 41 41 0 0 1 16.21-2.87q15.5 0 23.34 6.8t8.23 18.15l-16.63.73q-1.07-6.36-4.58-9.13t-10.53-2.78q-7.25 0-11.35 3a6 6 0 0 0-2.64 5.12 6.33 6.33 0 0 0 2.47 5q3.15 2.64 15.28 5.5t18 5.93a23.18 23.18 0 0 1 9.11 8.37 26 26 0 0 1-.65 26.38 23.59 23.59 0 0 1-11.13 9.19q-7.18 3-17.92 3-15.62 0-24-7.22t-9.98-21.08ZM961.41 170.3v-68.43H937V87.93h65.46v13.94H978v68.43ZM1538.47 196.3c-4.11-14.3-15-26.67-29.75-30.28a26.87 26.87 0 0 0-6.61-.85 27.62 27.62 0 0 0-3.83.39 68.55 68.55 0 0 1-1.42-8.62c-.26-2.16-.53-4.4-.95-6.55a68.21 68.21 0 0 1-1.15-9.91 13.52 13.52 0 0 1 3.28-1.57c.35-.14.53-.21.65-.27a74.23 74.23 0 0 0 8.22-4.52 31.88 31.88 0 0 0 7.25-6.28c2.7-3.26 7.19-9.79 6.89-16.91a12.88 12.88 0 0 0-4.42-9.32 15.05 15.05 0 0 0-9.84-3.44h-.63a26 26 0 0 0-11.56 3.27 36.22 36.22 0 0 0-9.49 7.64 46.3 46.3 0 0 0-10.85 21.24c-1.93 9.67-.5 18.85.89 27.72.28 1.78.57 3.63.82 5.44.06.37.12.73.19 1.1-.42.41-.82.83-1.2 1.27-2 2.32-3.33 5.35-5.4 7.57-1.47 1.59-3.35 2.75-4.86 4.33-4.55 4.75-9 9.61-13.58 14.3-6.67 6.78-13.46 13.42-20.27 20.05a14.79 14.79 0 0 1-3.12 1.83 18.44 18.44 0 0 1 .87-7.12c3.12-9.14 6.53-18.14 9.5-27.35 3.66-11.31 7.2-22.69 10.39-34.21 2.07-7.49.62-15.14-3.91-22.31s-11.26-9.48-17.9-5.9a40.14 40.14 0 0 0-7.47 5.27c-10.74 9.56-19.16 21.32-27.43 33.2-.58.82-1.2 1.61-2.15 2.88 1.37-5.09 2.85-9.42 3.68-14a33 33 0 0 0-2.8-21.33c-3.48-6.92-9.73-9.6-15.76-6.61a38.73 38.73 0 0 0-8.29 5.66c-11.5 10.08-20.64 22.46-29.8 34.8-3.82 5.16-7.47 10.47-11.2 15.71a6.34 6.34 0 0 1 .69-3.06q9.42-19.35 18.89-38.66c2.11-4.28 1.74-6.81-2.63-9.56a46 46 0 0 0-10.88-5c-7.46-2.27-8.19-1.79-11.91 4.61a22.06 22.06 0 0 0-1.5 2.74q-8.71 21-17.38 42c-.44 1-.76 2.49-1.59 2.95a32.83 32.83 0 0 1-16.89 4.09c.83-2.56 1.52-4.66 2.18-6.77a51.4 51.4 0 0 0 .89-29.32c-2.76-10.44-9.93-18.34-19-20.65-14.74-3.75-27.38 4.65-29.41 19.7-.44 3.23-.38 6.59-.57 10.07-1.6-1.85-3-3.6-4.49-5.15-6.59-6.64-12-7-17.78-1.08a36.68 36.68 0 0 0-4.31 5.22c-6.55 9.78-15.88 31-16.69 49.72-.65 14.94 4.16 28.22 20.2 32.62a39.19 39.19 0 0 0 28-2.53c15.19-7.18 25.67-19.52 33.88-34.18 1.86-3.32 3.61-5.35 7.91-5.05 3.29.24 6.49-1.17 9.72-1.86.74-.16 1.46-.37 2.15-.55-1.17 6.2-2.64 12-3.34 18.08-1.17 10.1 3.09 18.44 11.24 25a23.14 23.14 0 0 0 4.52 2.36c1.76-5.24 3-10.14 5-14.59a140.71 140.71 0 0 1 8.54-16c14.1-22.74 31.11-42.91 48.76-62.5a2.06 2.06 0 0 1 .63-.39c-4.62 13.56-9.61 27-13.74 40.72a177.57 177.57 0 0 0-6 28c-1.39 10.63 4.25 19 14.33 23.49 4.22 1.86 4.67 1.74 5.9-2.47a233.81 233.81 0 0 1 15.51-40.51c9.43-18.6 20.92-35.44 36.49-48.74.61-.51 1.32-.91 2-1.37a7.64 7.64 0 0 1-.7 3.07c-5 12.77-10.26 25.43-15 38.36-3.54 9.74-6.53 19.77-7.14 30.65a16.44 16.44 0 0 0 5.39 13.54 64.1 64.1 0 0 0 10 7 9.45 9.45 0 0 0 10.32.17 76.08 76.08 0 0 0 9.31-6.36c1.75-1.46 3.46-3 5.13-4.51 1.39 6.74 9.66 9.1 15.47 10.23 3.21.62 6.22.94 8.21 1.13 1.56.15 3.12.23 4.62.23a36.5 36.5 0 0 0 11.07-1.6 25.47 25.47 0 0 0 10.12-5.9 36.5 36.5 0 0 0 9.45-16.72 49.33 49.33 0 0 0 1.5-18.12 93.85 93.85 0 0 0-2.44-13.61c.91 0 1.81.11 2.71.22a26.19 26.19 0 0 1 6.47 1.87 34.39 34.39 0 0 1 8.64 4.79 33.89 33.89 0 0 1 11 15.47 40.91 40.91 0 0 1 1.31 4.73c.18.84.33 1.68.47 2.53v.32c.07.58.12 1.15.16 1.73a41.5 41.5 0 0 1 .08 4.6c0 .76-.08 1.53-.16 2.29 0 .07-.12.92-.11.91-.05.35-.11.7-.17 1.05-1.42 7.78-4.42 14-9.07 20.57-.32.45-.66.9-1 1.35l-.28.39c-.53.67-1.08 1.34-1.63 2-1.41 1.66-2.88 3.25-4.43 4.78s-2.88 2.76-4.4 4.07c-1.82 1.56-2.76 2.29-4.13 3.3a135.58 135.58 0 0 1-20.43 12.5q-2.52 1.24-5.08 2.37l-1.54.68c-1.12.48-.29.12 0 0-1 .43-2.09.85-3.13 1.26q-5.79 2.24-11.75 4a184.25 184.25 0 0 1-23.88 5.35l-2.83.42-1 .14-.67.09c-2.09.25-4.18.48-6.27.67q-6.29.59-12.58.77a222.63 222.63 0 0 1-24.91-.67c-4.69-.38-9.37-.89-14-1.5l-1.29-.17-1.36-.2c-1.12-.16-2.25-.32-3.37-.5q-3.88-.6-7.75-1.27c-9.64-1.69-19.24-3.62-28.8-5.73-18.14-4-36.11-9-54.39-12.29a198.92 198.92 0 0 0-28-3.36A155.57 155.57 0 0 0 1224 253c-14.46 2.14-29.42 7.44-39.55 18.48-4.69 5.11-8.26 12.16-5.1 19a13.89 13.89 0 0 0 7.4 6.73 21.75 21.75 0 0 0 4.59 1.41 30.52 30.52 0 0 0 5.5.59 25.4 25.4 0 0 0 9-1.3c4.57-1.54 2.61-8.83-2-7.27a16.36 16.36 0 0 1-7.6.31c-.71-.14-1.42-.34-2.12-.55l-1-.36-.59-.24a15.62 15.62 0 0 1-1.56-.84 8.8 8.8 0 0 1-.64-.42l-.57-.5c-.08-.07-.38-.4-.57-.61l-.06-.1c-.09-.18-.36-.8-.32-.64l-.1-.31c-.08-.29-.13-.58-.21-.87a5.09 5.09 0 0 0 0-.68v-.3c.17-.57.35-1.15.51-1.71-.36 1.28.22-.4.45-.8.33-.58.7-1.11 1.07-1.66l.09-.15.1-.11.82-1a39 39 0 0 1 3.12-3l1-.86.53-.43.53-.41 1.26-.9a58.14 58.14 0 0 1 7.44-4.43c6.59-3.27 15.44-5.19 22.55-6.05a159.24 159.24 0 0 1 54 3c18.14 4 36 9.26 54.07 13.54 19.32 4.57 38.92 8.21 58.74 9.67a214.91 214.91 0 0 0 50.1-2.16 160 160 0 0 0 47.12-15.25c3.48-1.78 6.89-3.71 10.19-5.79q2.36-1.49 4.65-3.08l1.37-1 1.51-1.14.71-.54c.78-.6 1.56-1.2 2.33-1.81a86.18 86.18 0 0 0 17.11-18.1c8.83-12.82 12.97-28.86 8.6-44.06Zm-303 12.93a32.49 32.49 0 0 1-10.67 6.26c-5.7 2-10.24-1.37-10.59-7.9a50.78 50.78 0 0 1 1.26-15.2c3.91-15.15 12.91-26.76 22.73-38.35 3.39 10.54 8.54 19.34 17.29 25.75-5.27 11.21-11.19 21.56-20.06 29.44Zm25.31-44.67-1.14.84c-1.16-1.44-2.38-2.83-3.47-4.33-6.19-8.48-9.33-17.69-8.76-27.71a12.18 12.18 0 0 1 .54-2.85c.94-3 2.66-5.38 6-5.48a7.89 7.89 0 0 1 7.71 5.11 44.66 44.66 0 0 1 3.18 12.37c.55 7.89-1.74 15.03-4.1 22.05Zm217.31 27.83a31.08 31.08 0 0 1-5.08 12.7c-3 4-6.74 6.19-11.21 6.36h-.36a4 4 0 0 1-3-1c-.69-.84-.68-2.44 0-4.28a57.47 57.47 0 0 1 3.64-7.75 45.37 45.37 0 0 1 4.5-6.46c.89-1.06 8.78-6.83 11.84-9a28.59 28.59 0 0 1-.37 9.43Zm15.91-68.68a22.29 22.29 0 0 1 1.9-7.4 16.74 16.74 0 0 1 4.75-6.21 10 10 0 0 1 4.46-2.21 5.17 5.17 0 0 1 1-.09 3.76 3.76 0 0 1 2.78 1c.61.65 1.46 2.31.38 6.07a28.46 28.46 0 0 1-9.41 13.86c-1.66 1.36-2.9 2.31-3.65 2.87a30.08 30.08 0 0 1-2.7 1.83c-.01-2.65.36-8.7.49-9.72Zm-304.8 163.77c.28.33.13.18 0 0Z"
                    />
                    <path
                        fill="#fff"
                        d="M1309.73 39.38c-8.22-6.67-19.26-8.29-29.47-9.22a237 237 0 0 0-34.22-.83c-46.23 2.48-92 11.71-136.18 20.63-11.11 2.24-22.46 4.53-33.83 6.71a82 82 0 0 0-2.4-11.85c-5.57-19.81-20.5-31.39-39.92-30.95-17.1.38-36.66 9.06-38.34 28.54a35.23 35.23 0 0 0 .21 7.38 22.94 22.94 0 0 0 5.57 13.21c3.63 4.14 8.8 7.16 15.37 9 10.6 2.92 21.56 2.08 31.84.51-.55 10.2-2.19 20.77-4.16 32.37a10.42 10.42 0 0 1-.82 1.25l-.32.44c-3.45 4.87-7 9.77-10.5 14.52-7.6 10.4-15.45 21.15-22.46 32.26-15.24 24.15-25.21 46.63-30.49 68.73-1.68 7-3.23 16.38-.22 26.09 2.34 7.55 8.15 11.89 15.41 11.89a20.15 20.15 0 0 0 4.71-.58c6.93-1.66 13-5.53 19.26-12.2 14.9-16 23.92-35.52 30.78-52.52 11.19-27.73 19.4-59.08 25.85-98.68a10.66 10.66 0 0 1 .27-1.25c1.1-.68 2.19-1.38 3.28-2.08 4.72-3 9.19-5.86 14-7.75 5.89-2.32 8.87 1.59 10.34 5.28a41.11 41.11 0 0 1 2.42 9.18c2 13.36 1.25 27.6-2.31 46.15-2.69 14.07-6 28.31-9.17 42.07-1.47 6.36-3 12.94-4.44 19.43-2.25 10.13 2.89 19 12.81 22 2.65.81 6.09 1.52 9.14-.17s4.19-4.85 4.88-7.44q2.7-10.14 5.35-20.28c4.16-15.84 8.47-31.63 12.8-47.42 4.22-15.39 7.73-31.21 14.08-45.9 6.56-15.18 14-26.19 22.79-33.66l.35-.3c3.17-2.7 4.57-3.55 6.1-2.91 1.27.53 2.41 1.69 2.16 6.61-.08 1.62-.15 3.25-.22 4.88-1.66 38.82-17.63 75.84-26 113.51-2.89 13-5 26.38-3.62 39.63.84 7.75 3.38 16.06 9.9 20.32a16.43 16.43 0 0 0 16.91.4c-5-7.3-6.43-16.53-5.77-25.34s3.28-17.33 5.88-25.77l16.23-52.71c6.34-20.56 12.74-41.51 12.74-63 0-5.91-.5-11.91-2.6-17.44-.13-.33-.26-.67-.4-1-2.17-5.12-5.87-9.71-10.87-12.11-5.65-2.71-12.43-2.35-18.31-.18-12.16 4.5-21.39 15-28 25.73a146.77 146.77 0 0 0-9.89 18.2 142.72 142.72 0 0 0-3.35 8.67 73.69 73.69 0 0 0-5.9-24.35c-6-13.14-17.75-19.73-31.42-17.63-5 .78-9.82 2.66-14.69 4.68a37.54 37.54 0 0 0-4 2c.1-3 .11-5.93 0-8.72 11.82-2.26 23.6-4.64 35.12-7 44.53-9 89.42-18.24 134.91-20.45 17.6-.86 36.3-1.12 53.13 4.85 4.58 1.64 9.09 4.35 9.21 9.81.14 6.74-7.24 10.63-12.64 12.71a37.16 37.16 0 0 1-15.72 2.5 44.37 44.37 0 0 1-14.73-3.26 13.2 13.2 0 0 1-3.42-2.14c-.84-.72-2.21-1.86-2.28-3.07-1.48 4.57-2 9.87 2.3 13.5 5.16 4.38 13.63 6 20.17 6 .76 0 1.51 0 2.27-.06 11.53-.66 24.57-6.46 30-17.23 4.23-8.57 1.88-18.22-5.46-24.19ZM1028.34 165c-7.73 21.71-16.4 42.46-23.86 59.89-2.16 5-6 9.8-9.66 14.41l-1.26 1.58a5.24 5.24 0 0 1-1.5.81 6.38 6.38 0 0 1-.63-1.72c1.19-8.61 2.36-16.34 4.72-23.67 5.56-17.3 15.15-41.34 40.11-77.65-2.37 8.83-4.87 17.8-7.92 26.35Zm-9-103.31c-4.52-1.24-7.94-3.17-10.17-5.71a12.77 12.77 0 0 1-1.09-1.45 13.61 13.61 0 0 1-1.89-5.77 9.72 9.72 0 0 1 0-1.62 17.09 17.09 0 0 1 4.41-8.95 29.92 29.92 0 0 1 11.81-7.81c10.6-3.61 18.94.32 22.89 10.76a31 31 0 0 1 1.48 5.17 98 98 0 0 1 1.66 15.36c-9.85 1.62-19.83 2.59-29.08.04ZM18.88 97.54 15.56 82.6h16.75l32.61-36.29a1.2 1.2 0 0 1 .87-.39h147l5.9-11.6-2.88-3.91H65.79a16.7 16.7 0 0 0-12.4 5.53L4.28 90.59a16.66 16.66 0 0 0-.08 22.21L28.32 140l-6.93-31.2"
                    />
                    <path
                        fill="#fff"
                        d="M29.6 92.74h23l8.28 43.6 12.09-43.6h22.75l12.14 43.59 8.29-43.59H139L121.76 171h-23.7l-13.72-49.29L70.69 171H47ZM185.06 132.83a16 16 0 0 0-6.28-5.78 53.06 53.06 0 0 0-11.87-3.93c-6.32-1.49-8.66-2.66-9.51-3.37a3.14 3.14 0 0 1-1.26-2.5 2.92 2.92 0 0 1 1.31-2.53 11.49 11.49 0 0 1 6.8-1.75c2.8 0 4.89.54 6.23 1.6s2.19 2.83 2.61 5.32l.15.84 12.6-.55v-1a16.56 16.56 0 0 0-5.67-12.47c-3.55-3.08-8.86-4.64-15.77-4.64a27.92 27.92 0 0 0-10.9 1.93 15.45 15.45 0 0 0-7.1 5.78 14.71 14.71 0 0 0-2.47 8.16 14.89 14.89 0 0 0 5.24 11.47c2.48 2.22 6.59 4 12.59 5.5 4.44 1.11 7.32 1.89 8.54 2.31a8 8 0 0 1 3.46 2 3.87 3.87 0 0 1 .89 2.6 5.62 5.62 0 0 1-2.29 4.42c-1.58 1.31-4 2-7.24 2a10.74 10.74 0 0 1-7.22-2.24c-1.75-1.5-2.93-3.92-3.52-7.2l-.16-.88-12.37 1.21.12 1c.73 6.2 3 11 6.81 14.27s9.23 4.91 16.2 4.91a31.38 31.38 0 0 0 12-2 16.3 16.3 0 0 0 7.66-6.33 16.71 16.71 0 0 0 2.7-9.12 16.89 16.89 0 0 0-2.28-9.03Z"
                    />
                    <path
                        d="M274.45 29.9a1 1 0 0 0 .13-1.14 1.07 1.07 0 0 0-.53-.47l-18.85-7.2a1 1 0 0 1-.62-.7L249.82.77a1 1 0 0 0-1-.77 1 1 0 0 0-.79.38l-12.68 15.7a1 1 0 0 1-.79.37h-.07l-20.09-1.54h-.07a1 1 0 0 0-.86 1.56l11 16.91a1 1 0 0 1 .09.93l-6.8 16.52-.4 1-.46 1.17a1 1 0 0 0 .09 1l.08.1a1 1 0 0 0 .59.33h.14a1.09 1.09 0 0 0 .25 0l19.49-5.25a.84.84 0 0 1 .27 0 1.08 1.08 0 0 1 .64.24l15.38 13.08a1 1 0 0 0 .25.16h.14a.31.31 0 0 0 .13 0h.12a1 1 0 0 0 .74-.31 1 1 0 0 0 .28-.65l.85-16.7.18-3.46a1.07 1.07 0 0 1 .19-.54 1.16 1.16 0 0 1 .28-.26l17.23-10.64a1.1 1.1 0 0 0 .23-.2Z"
                        fill="url(#linear-gradient)"
                    />
                    <path
                        fill="#fff"
                        d="M291.29 71.13h.2l-12.14-12.4-13.81-14.04-3.14 2.24-.87 15.87 10.09 10.29c4.97-.68 10.8-1.26 19.67-1.96ZM238.65 185.88a18.67 18.67 0 0 1-7.76-4.63l-70.8 81.88a1 1 0 0 1-.35.27 1.07 1.07 0 0 1-.42.1 1.16 1.16 0 0 1-.87-.39l-80.29-90.33-2.06 7.44H64l82.72 93.22a16.69 16.69 0 0 0 12.47 5.6h.11a16.81 16.81 0 0 0 12.57-5.8l75.17-87a15.34 15.34 0 0 1-8.39-.36Z"
                    />
                    <path
                        fill="#fff"
                        d="M324.24 84.09c-4.23-3.26-9.82-3.94-15-4.28a118.65 118.65 0 0 0-17.28 0c-23.29 1.83-24.76 2.76-47.08 7.26-5.61 1.13-11.34 2.29-17.08 3.39a40.82 40.82 0 0 0-1.21-6c-2.82-10-10.35-15.85-20.15-15.63-8.63.2-18.51 4.58-19.35 14.41a17 17 0 0 0 .1 3.73 11.55 11.55 0 0 0 2.81 6.72 15.42 15.42 0 0 0 7.76 4.53c5.35 1.48 10.88 1 16.07.26a144.71 144.71 0 0 1-2.1 16.34 5.45 5.45 0 0 1-.41.63l-.17.23c-1.73 2.45-3.54 4.93-5.29 7.32-3.84 5.25-7.8 10.68-11.34 16.29-7.69 12.19-12.73 23.53-15.39 34.69-.85 3.56-1.63 8.27-.11 13.17a7.93 7.93 0 0 0 7.77 6 10.61 10.61 0 0 0 2.39-.29c3.49-.84 6.58-2.8 9.71-6.16 7.53-8.07 12.08-17.93 15.54-26.51 5.65-14 9.8-29.83 13.05-49.81a4.21 4.21 0 0 1 .14-.63l1.65-1a42.7 42.7 0 0 1 7.05-3.91c3-1.18 4.48.8 5.22 2.66a21.12 21.12 0 0 1 1.23 4.63c1 6.75.63 13.93-1.17 23.3-1.36 7.1-3 14.29-4.63 21.24-.74 3.21-1.51 6.53-2.24 9.8a9.09 9.09 0 0 0 6.47 11.12 5.83 5.83 0 0 0 4.61-.09 5.67 5.67 0 0 0 2.46-3.75q1.36-5.12 2.7-10.24c2.1-8 4.28-16 6.46-23.94 2.14-7.76 3.91-15.75 7.11-23.16 3.31-7.67 7.08-13.23 11.51-17l.17-.15c1.6-1.36 2.31-1.79 3.08-1.47s1.22.86 1.09 3.34c0 .82-.07 1.64-.11 2.46-.84 19.6-8.9 38.29-13.12 57.3-1.46 6.57-2.54 13.32-1.82 20 .42 3.91 1.7 8.11 5 10.26a8.29 8.29 0 0 0 8.54.2c-2.51-3.68-3.25-8.34-2.92-12.79a60.18 60.18 0 0 1 3-13q4.1-13.31 8.2-26.61c3.2-10.38 6.42-21 6.43-31.82a24.94 24.94 0 0 0-1.31-8.8l-.21-.51a11.68 11.68 0 0 0-5.48-6.11 12 12 0 0 0-9.25-.09c-6.14 2.26-10.79 7.54-14.13 13a73.8 73.8 0 0 0-5 9.19c-.62 1.43-1.17 2.89-1.69 4.37a37.3 37.3 0 0 0-3-12.28c-3-6.64-9-10-15.86-8.9a32.47 32.47 0 0 0-7.42 2.36 18.2 18.2 0 0 0-2 1c0-1.53.06-3 0-4.4 6-1.14 11.91-2.34 17.72-3.51 22.48-4.54 23.66-5.5 46.59-7.19 8.87-.65 18.3-1 26.87 1.77 2.33.77 4.64 2.08 4.77 4.84.16 3.4-3.52 5.45-6.21 6.57a18.72 18.72 0 0 1-7.9 1.46 22.69 22.69 0 0 1-7.48-1.45 6.86 6.86 0 0 1-1.75-1c-.44-.36-1.14-.92-1.19-1.52-.69 2.32-.88 5 1.33 6.78 2.66 2.14 6.95 2.83 10.25 2.75.38 0 .77 0 1.15-.06 5.81-.48 12.31-3.57 14.89-9.07a9.78 9.78 0 0 0-3.04-12.24Zm-120.5 61.08c-3.91 11-8.28 21.43-12.05 30.23a33.38 33.38 0 0 1-4.87 7.27l-.64.8a2.5 2.5 0 0 1-.76.41 3.17 3.17 0 0 1-.31-.87 69.62 69.62 0 0 1 2.38-11.95c2.8-8.73 7.65-20.86 20.25-39.19-1.2 4.45-2.46 8.97-4 13.3ZM199.2 93a10.16 10.16 0 0 1-5.13-2.88 5.58 5.58 0 0 1-.55-.73 7 7 0 0 1-1-2.91 5.57 5.57 0 0 1 0-.82 8.59 8.59 0 0 1 2.22-4.52 15.13 15.13 0 0 1 6-3.94c5.35-1.82 9.57.16 11.56 5.43a16.45 16.45 0 0 1 .75 2.61 50 50 0 0 1 .83 7.75c-4.97.83-10.01 1.32-14.68.01Z"
                    />
                </g>
            </g>
        </>,
    ],
});

export const PaginationLeft = createIcon({
    displayName: "PaginationLeftIcon",
    viewBox: "0 0 100 100",
    path: [
        <path
            key="0"
            fill="currentColor"
            d="M58.4,64.58l29.17-29.16H41.59c-16.1,0.02-29.14,13.06-29.16,29.16H58.4z"
        />,
    ],
});

export const KeyIcon = createIcon({
    displayName: "KeyIcon",
    viewBox: "0 0 100 100",
    path: [
        <path
            key="0"
            fill="currentColor"
            d="M74.38,39.65l-4.86-4.87l1.16-1.17c1.61-1.6,1.61-4.23,0-5.84c-1.61-1.62-4.24-1.62-5.85,0L44.74,47.86
            c-1.85-0.96-3.97-1.5-6.2-1.5C31.06,46.36,25,52.42,25,59.9c0,7.48,6.06,13.54,13.54,13.54c7.48,0,13.54-6.06,13.54-13.54
            c0-2.23-0.54-4.34-1.5-6.2l8.68-8.67l4.86,4.86c0.83,0.83,2.17,0.83,3,0l7.25-7.25C75.21,41.81,75.21,40.48,74.38,39.65z
            M38.54,65.11c-2.87,0-5.21-2.33-5.21-5.21c0-2.87,2.33-5.21,5.21-5.21s5.21,2.33,5.21,5.21C43.75,62.77,41.42,65.11,38.54,65.11z"
        />,
    ],
});

export const PurIcon = createIcon({
    displayName: "BrPurIcon",
    viewBox: "0 0 3444.74 700.39",
    path: [
        <path
            key="0"
            fill="currentColor"
            d="M3444.74,223.62C3444.74,100.12,3344.62,0,3221.12,0v0.02L2396.48,0
	c0,95.38,77.32,172.71,172.71,172.71h640.58c28.11,0,50.9,22.79,50.9,50.9s-22.79,50.9-50.9,50.9v-0.02h-640.49
	c-95.43,0-172.8,77.37-172.8,172.8V693.4h193.81V447.21H3040l146.18,246.19h229.21l-163.08-248.58
	c108.69-15.21,192.42-108.31,192.42-221.19L3444.74,223.62z"
        />,
        <path
            key="1"
            fill="currentColor"
            d="M855.83,444.83c89.81,0,192.42-108.31,192.42-221.19c0.01-123.5-100.11-223.62-223.61-223.62v0.02
	L0,0.02C0,95.4,77.32,172.73,172.71,172.73h640.58c28.11,0,50.9,22.79,50.9,50.9s-22.79,50.9-50.9,50.9v-0.02H172.8
	C77.37,274.5,0,351.87,0,447.3v246.11h193.81V447.22h449.71C643.52,447.22,766.03,444.83,855.83,444.83L855.83,444.83z"
        />,
        <path
            key="2"
            fill="currentColor"
            d="M2100.68,333.58c0,101.25-75.11,174.74-178.6,174.74h-411.96c-103.49,0-178.6-73.5-178.6-174.74
	l3.47-333.56h-207.3l0.74,334.33c0,211.41,156.96,359.05,381.69,359.05h411.96c224.73,0,381.69-147.64,381.69-359.05V0.02H2101.2
	l-0.52,333.57L2100.68,333.58z"
        />,
    ],
});

export const GasIcon = createIcon({
    displayName: "GasIcon",
    viewBox: "0 0 300 300",
    path: [
        <path
            key="1"
            fill="currentColor"
            d="M212.2,62h-37.49c-3.99,0-7.81,1.65-10.54,4.57l-17.01,18.14H87.8c-7.98,0-14.45,6.47-14.45,14.45v124.4
    c0,7.98,6.47,14.45,14.45,14.45h124.4c7.98,0,14.45-6.47,14.45-14.45V121.61v-36.9v-8.26C226.65,68.47,220.18,62,212.2,62z
     M206.77,109.59c0,2.72-2.21,4.93-4.93,4.93h-43.4c-4.3,0-6.54-5.12-3.61-8.28l20.82-22.44c0.93-1,2.24-1.58,3.61-1.58h22.58
    c2.72,0,4.93,2.21,4.93,4.93V109.59z"
        />,
        <path
            key="2"
            fill="currentColor"
            d="M134.39,79.03h-51.1V72.1c0-5.58,4.52-10.1,10.1-10.1h30.89c5.58,0,10.1,4.52,10.1,10.1V79.03z"
        />,
    ],
});

export const EthIcon = createIcon({
    displayName: "EthIcon",
    viewBox: "0 0 300 300",
    path: [
        <polygon
            key="1"
            fill="currentColor"
            points="86,151.93 86,151.93 149.98,189.75 149.98,189.75 213.96,151.93 149.98,45.77 149.98,45.77 149.98,45.77 
		149.98,45.77 149.98,45.77 86,151.93 	"
        />,
        <polygon
            key="2"
            fill="currentColor"
            points="214,164.07 149.98,201.87 149.98,201.87 86,164.07 149.98,254.22 149.98,254.23 	"
        />,
    ],
});

export const ListPriceIcon = createIcon({
    displayName: "ListPriceIcon",
    viewBox: "0 0 300 300",
    path: [
        <path
            key="1"
            fill="currentColor"
            d="M241.95,44.04l-83.72-0.17c-3.73-0.01-7.32,1.47-9.96,4.11L47.98,148.26c-5.49,5.49-5.49,14.38,0,19.86l83.89,83.89
	c5.49,5.49,14.38,5.49,19.86,0l100.28-100.28c2.64-2.64,4.12-6.22,4.11-9.96l-0.17-83.72C255.95,50.32,249.68,44.05,241.95,44.04z
	 M188.1,154.21c0.3,5.55-1.41,11.2-5.11,16.93l12.95,12.95l-10.06,10.06l-12.47-12.47c-4.08,3.43-8.27,5.94-12.59,7.52
	c-4.32,1.58-8.57,2.37-12.75,2.37l-0.64-14.8c7.51-0.54,13.65-3.19,18.42-7.96c2.47-2.47,3.83-4.85,4.1-7.16
	c0.27-2.31-0.46-4.32-2.17-6.03c-1.23-1.23-2.51-2-3.82-2.29c-1.31-0.29-2.96-0.12-4.95,0.52c-1.98,0.64-4.59,1.83-7.8,3.54
	c-7.88,4.13-14.4,6.09-19.55,5.87c-5.15-0.21-9.73-2.33-13.76-6.35c-4.13-4.13-6.15-8.97-6.07-14.52
	c0.08-5.55,2.05-11.01,5.91-16.37l-11.91-11.91l10.06-10.06l11.99,11.99c6.27-4.56,13.01-6.84,20.19-6.84l1.05,13.92
	c-6.44,0.64-11.72,3.03-15.85,7.16c-2.04,2.04-3.23,4.01-3.58,5.91c-0.35,1.9,0.2,3.58,1.65,5.03c1.02,1.02,2.15,1.58,3.38,1.69
	c1.23,0.11,2.84-0.21,4.83-0.97c1.98-0.75,4.83-2.06,8.53-3.94c7.19-3.75,13.37-5.59,18.54-5.51c5.17,0.08,10.1,2.45,14.76,7.12
	C185.57,143.79,187.81,148.66,188.1,154.21z M227.82,89.94c-4.91,4.91-12.86,4.91-17.76,0c-4.91-4.91-4.91-12.86,0-17.76
	c4.91-4.91,12.86-4.91,17.76,0C232.72,77.09,232.72,85.04,227.82,89.94z"
        />,
    ],
});

export const FeatureIcon = createIcon({
    displayName: "FeatureIcon",
    viewBox: "0 0 300 300",
    path: [
        <path
            key="1"
            fill="currentColor"
            d="M69,259.21c-1.52,0-3.05-0.34-4.47-1.03c-3.51-1.71-5.73-5.27-5.73-9.17v-47.61c-11.28-4.16-19.34-15.02-19.34-27.73
			V70.34c0-16.29,13.26-29.55,29.55-29.55h161c16.29,0,29.55,13.26,29.55,29.55v103.31c0,16.29-13.26,29.55-29.55,29.55h-85.82
			l-68.9,53.84C73.45,258.47,71.23,259.21,69,259.21z M69,61.21c-5.04,0-9.14,4.1-9.14,9.14v103.31c0,5.04,4.1,9.14,9.14,9.14
			c5.64,0,10.21,4.57,10.21,10.21v35.07l55.18-43.11c1.79-1.4,4.01-2.16,6.28-2.16H230c5.04,0,9.14-4.1,9.14-9.14V70.34
			c0-5.04-4.1-9.14-9.14-9.14H69z"
        />,
        <path
            key="2"
            fill="currentColor"
            d="M131.72,95c1.28,0,2.48,0.24,3.59,0.72c1.11,0.48,2.07,1.14,2.89,1.98c0.82,0.84,1.47,1.83,1.95,2.97
			c0.48,1.14,0.72,2.39,0.72,3.75c0,1.32-0.24,2.55-0.72,3.69c-0.48,1.14-1.13,2.14-1.95,3c-0.82,0.86-1.78,1.53-2.89,2.01
			c-1.11,0.48-2.3,0.72-3.59,0.72c-1.28,0-2.49-0.24-3.61-0.72c-1.12-0.48-2.1-1.15-2.92-2.01c-0.82-0.86-1.46-1.86-1.93-3
			c-0.46-1.14-0.7-2.37-0.7-3.69c0-1.36,0.23-2.61,0.7-3.75c0.46-1.14,1.1-2.13,1.93-2.97c0.82-0.84,1.79-1.5,2.92-1.98
			C129.23,95.24,130.44,95,131.72,95z M168.28,95c1.28,0,2.48,0.24,3.59,0.72c1.11,0.48,2.07,1.14,2.89,1.98
			c0.82,0.84,1.47,1.83,1.95,2.97c0.48,1.14,0.72,2.39,0.72,3.75c0,1.32-0.24,2.55-0.72,3.69c-0.48,1.14-1.13,2.14-1.95,3
			c-0.82,0.86-1.78,1.53-2.89,2.01c-1.11,0.48-2.3,0.72-3.59,0.72s-2.49-0.24-3.61-0.72c-1.12-0.48-2.1-1.15-2.92-2.01
			c-0.82-0.86-1.46-1.86-1.93-3c-0.46-1.14-0.7-2.37-0.7-3.69c0-1.36,0.23-2.61,0.7-3.75c0.46-1.14,1.1-2.13,1.93-2.97
			c0.82-0.84,1.79-1.5,2.92-1.98C165.79,95.24,166.99,95,168.28,95z"
        />,
        <path
            key="3"
            fill="currentColor"
            d="M149.97,136.66c3.53,0,7.08-0.21,10.65-0.62s7.09-1.02,10.57-1.82c3.48-0.8,6.87-1.77,10.17-2.92
			c3.3-1.14,6.45-2.43,9.45-3.85c0.86-0.46,1.61-0.73,2.28-0.8c0.66-0.07,1.24-0.01,1.74,0.19c0.5,0.19,0.93,0.48,1.28,0.86
			c0.36,0.37,0.68,0.79,0.96,1.26l4.28,7.39c-8.07,5.17-16.36,8.91-24.89,11.21c-8.53,2.3-17.36,3.45-26.49,3.45
			c-9.17,0-18.01-1.15-26.52-3.45c-8.51-2.3-16.78-6.04-24.81-11.21l4.28-7.39c0.29-0.46,0.61-0.88,0.96-1.26
			c0.36-0.37,0.79-0.66,1.28-0.86c0.5-0.2,1.08-0.26,1.74-0.19c0.66,0.07,1.42,0.34,2.27,0.8c3,1.43,6.15,2.71,9.45,3.85
			c3.3,1.14,6.68,2.11,10.14,2.92c3.46,0.8,6.97,1.41,10.54,1.82C142.89,136.45,146.44,136.66,149.97,136.66z"
        />,
    ],
});

export const InfoIcon = createIcon({
    displayName: "InfoIcon",
    viewBox: "0 0 300 300",
    path: [
        <path
            key="1"
            fill="currentColor"
            d="M150,255c-57.9,0-105-47.1-105-105S92.1,45,150,45s105,47.1,105,105S207.9,255,150,255z M150,58.55
			c-50.43,0-91.45,41.03-91.45,91.45s41.03,91.45,91.45,91.45s91.45-41.03,91.45-91.45S200.43,58.55,150,58.55z"
        />,
        <path
            key="2"
            fill="currentColor"
            d="M161.43,90.62c2.95,2.9,4.43,6.53,4.43,10.88c0,4.35-1.48,7.98-4.43,10.88c-2.95,2.9-6.76,4.35-11.43,4.35
				c-4.66,0-8.47-1.45-11.43-4.35c-2.95-2.9-4.43-6.53-4.43-10.88c0-4.35,1.48-7.98,4.43-10.88c2.95-2.9,6.76-4.35,11.43-4.35
				C154.66,86.26,158.47,87.72,161.43,90.62z M163.84,130.88v82.86h-27.67v-82.86H163.84z"
        />,
        <path
            key="3"
            fill="currentColor"
            d="M164.25,214.15h-28.49v-83.68h28.49V214.15z M136.58,213.33h26.85v-82.03h-26.85V213.33z M150,117.14
				c-4.75,0-8.7-1.5-11.71-4.47c-3.02-2.97-4.55-6.73-4.55-11.18c0-4.45,1.53-8.21,4.55-11.18c3.02-2.97,6.96-4.47,11.71-4.47
				c4.75,0,8.69,1.5,11.71,4.47h0c3.02,2.97,4.55,6.73,4.55,11.18c0,4.45-1.53,8.21-4.55,11.18
				C158.7,115.64,154.75,117.14,150,117.14z M150,86.68c-4.53,0-8.28,1.42-11.14,4.23c-2.86,2.81-4.31,6.37-4.31,10.59
				c0,4.22,1.45,7.78,4.31,10.59c2.86,2.81,6.61,4.23,11.14,4.23s8.28-1.42,11.14-4.23c2.86-2.81,4.31-6.37,4.31-10.59
				c0-4.22-1.45-7.78-4.31-10.59l0,0C158.28,88.1,154.53,86.68,150,86.68z"
        />,
    ],
});

export const EthWalletIcon = createIcon({
    displayName: "EthWalletIcon",
    viewBox: "0 0 22 17",
    path: [
        <mask
            key="0"
            id="mask0_70_778"
            // style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="22"
            height="17"
        >
            <path
                // fillRule="evenodd"
                // clipRule="evenodd"
                d="M0.5 0.833496H21.207V16.3335H0.5V0.833496Z"
                fill="white"
            />
        </mask>,
        <g key="1" mask="url(#mask0_70_778)">
            <path
                // fillRule="evenodd"
                // clipRule="evenodd"
                d="M9.477 14.1668C8.63117 14.8932 7.533 15.3335 6.33333 15.3335C3.66833 15.3335 1.5 13.1652 1.5 10.5002C1.5 8.968 2.2175 7.601 3.33333 6.71483C3.4925 6.5885 3.65883 6.471 3.83333 6.36516C3.99383 6.26766 4.16117 6.18033 4.33333 6.10183C4.94333 5.82333 5.62017 5.66683 6.33333 5.66683C8.99833 5.66683 11.1667 7.83516 11.1667 10.5002C11.1667 11.4852 10.8698 12.402 10.3617 13.1668C10.2453 13.342 10.1177 13.5087 9.98 13.6668C9.82467 13.8455 9.65667 14.0127 9.477 14.1668ZM18.899 12.5507C18.899 12.8847 18.6168 13.1668 18.2828 13.1668H11.5187C11.9318 12.367 12.1667 11.4607 12.1667 10.5002C12.1667 7.28366 9.54983 4.66683 6.33333 4.66683C5.631 4.66683 4.95733 4.79166 4.33333 5.02016V2.44966C4.33333 2.11566 4.6155 1.8335 4.9495 1.8335H18.2828C18.6168 1.8335 18.899 2.11566 18.899 2.44966V4.778H15.6897C15.2077 4.778 14.7587 5.016 14.4883 5.41466L13.7742 6.46733C13.4492 6.94633 13.4542 7.58666 13.7868 8.0605L14.4915 9.0655C14.7628 9.4525 15.2072 9.68366 15.68 9.68366H18.899V12.5507ZM20.207 8.0845C20.207 8.30866 20.0818 8.50216 19.899 8.60483C19.8123 8.6535 19.714 8.68366 19.6077 8.68366H19.3988H18.899H15.68C15.5328 8.68366 15.3948 8.61183 15.3103 8.49133L14.6055 7.48633C14.5098 7.35016 14.5085 7.16633 14.6017 7.02866L15.3157 5.97583C15.3998 5.852 15.5397 5.778 15.6897 5.778H18.899H19.3988H19.6077C19.714 5.778 19.8123 5.80816 19.899 5.85683C20.0818 5.9595 20.207 6.153 20.207 6.37716V8.0845ZM19.899 4.80583V2.44966C19.899 1.56083 19.1717 0.833496 18.2828 0.833496H4.9495C4.0605 0.833496 3.33333 1.56083 3.33333 2.44966V5.49966C1.63717 6.521 0.5 8.38016 0.5 10.5002C0.5 13.7167 3.11683 16.3335 6.33333 16.3335C8.16167 16.3335 9.79533 15.4873 10.8657 14.1668H18.2828C19.1717 14.1668 19.899 13.4395 19.899 12.5507V9.65566C20.642 9.51833 21.207 8.86666 21.207 8.0845V6.37716C21.207 5.59483 20.642 4.94333 19.899 4.80583Z"
                fill="currentColor"
            />
        </g>,
        <path
            key="2"
            // fillRule="evenodd"
            // clipRule="evenodd"
            d="M17.3399 6.49023C16.8936 6.49023 16.5317 6.85207 16.5317 7.29823C16.5317 7.74457 16.8936 8.1064 17.3399 8.1064C17.7862 8.1064 18.1481 7.74457 18.1481 7.29823C18.1481 6.85207 17.7862 6.49023 17.3399 6.49023Z"
            fill="currentColor"
        />,
        <path
            key="3"
            // fillRule="evenodd"
            // clipRule="evenodd"
            d="M8.846 13.167C8.64367 13.3578 8.41983 13.5258 8.17833 13.667C7.636 13.9842 7.00567 14.167 6.33333 14.167C5.096 14.167 4.00067 13.5503 3.33633 12.6088C2.91517 12.0118 2.66667 11.2848 2.66667 10.5003C2.66667 9.71766 2.91383 8.99216 3.33333 8.39599C3.48 8.18766 3.6475 7.99499 3.83333 7.82149C3.98817 7.67699 4.15533 7.54583 4.33333 7.42949C4.909 7.05333 5.59583 6.83366 6.33333 6.83366C8.35517 6.83366 10 8.47849 10 10.5003C10 11.5503 9.55567 12.498 8.846 13.167ZM6.33333 6.16699C5.61217 6.16699 4.93217 6.34499 4.33333 6.65799C4.15933 6.74899 3.9925 6.85133 3.83333 6.96416C3.65633 7.08966 3.48933 7.22783 3.33333 7.37783C2.51233 8.16683 2 9.27449 2 10.5003C2 12.8898 3.94383 14.8337 6.33333 14.8337C7.18017 14.8337 7.97033 14.5887 8.6385 14.167C8.87033 14.0207 9.0875 13.8532 9.287 13.667C9.4525 13.5127 9.6055 13.3453 9.74533 13.167C10.3217 12.431 10.6667 11.5055 10.6667 10.5003C10.6667 8.11083 8.72283 6.16699 6.33333 6.16699Z"
            fill="currentColor"
        />,
        <path
            key="4"
            // fillRule="evenodd"
            // clipRule="evenodd"
            d="M4.53955 10.7028L6.37305 11.828L8.20672 10.7028L6.37305 7.63379L4.53955 10.7028Z"
            fill="currentColor"
        />,
        <path
            key="5"
            // fillRule="evenodd"
            // clipRule="evenodd"
            d="M4.53955 11.0322L6.04805 13.1667L6.37305 13.6269L6.69822 13.1667L8.20672 11.0322L6.37305 12.1574L4.53955 11.0322Z"
            fill="currentColor"
        />,
    ],
});

export const ProjectionLineLegendIcon = createIcon({
    displayName: "ProjectionLineLegendIcon",
    viewBox: "0 0 15 12",
    path: [
        <g key="0" filter="url(#filter0_d_87_76512)">
            ,
            <mask id="path-1-inside-1_87_76512" fill="white">
                <path
                    // fillRule="evenodd"
                    // clipRule="evenodd"
                    d="M2.65015 8.37939C5.33179 8.37939 6.59253 7.33887 7.65015 4.87939C8.70776 2.41992 9.73022 1.37939 12.6501 1.37939"
                />
            </mask>
            <path
                d="M2.65015 10.3794C4.24864 10.3794 5.69691 10.0674 6.93334 9.17073C8.13821 8.29692 8.89753 7.04138 9.48747 5.66948L5.81282 4.08931C5.34515 5.17688 4.94529 5.67134 4.58497 5.93266C4.25621 6.17108 3.73329 6.37939 2.65015 6.37939L2.65015 10.3794ZM9.48747 5.66948C9.9876 4.50643 10.3391 4.04286 10.6558 3.80407C10.9235 3.60225 11.412 3.37939 12.6501 3.37939V-0.620605C10.9684 -0.620605 9.48569 -0.3232 8.24777 0.610112C7.05887 1.50646 6.37031 2.79289 5.81282 4.08931L9.48747 5.66948Z"
                fill="currentColor"
                mask="url(#path-1-inside-1_87_76512)"
            />
        </g>,
        <defs key="1">
            <filter
                id="filter0_d_87_76512"
                x="0.650146"
                y="0.379395"
                width="14"
                height="11"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="1" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.14902 0 0 0 0 0.172549 0 0 0 0 0.235294 0 0 0 0.688647 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_87_76512"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_87_76512"
                    result="shape"
                />
            </filter>
        </defs>,
    ],
});

export const GemXyzIcon = createIcon({
    displayName: "Gem XYZ Icon",
    viewBox: "0 0 23 17",
    path: [
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.2871 3.21377C21.2871 3.21377 22.6289 4.68109 22.7289 4.83651H22.7277C23.116 5.44104 23.0827 6.08099 22.668 6.69238C21.7889 7.98836 17.6713 11.9249 15.0317 14.4485C14.2218 15.2227 13.5511 15.8639 13.1557 16.2551C12.1642 17.2368 10.8741 17.2516 9.88497 16.2791C9.18421 15.5897 6.91594 13.3128 4.89019 11.2793C3.57829 9.96245 2.36809 8.74765 1.75126 8.13227C1.62364 7.98153 1.4599 7.81422 1.28391 7.6344C0.674098 7.01131 -0.0827078 6.23802 0.00733769 5.48332C0.0199748 5.38275 0.0429514 5.28562 0.0739698 5.19191C0.194597 4.82965 0.445041 4.50853 0.695486 4.21255C1.59808 3.14537 2.60522 2.17087 3.61066 1.19801L3.6273 1.18191C4.88956 -0.0360805 6.05907 -0.0176051 7.61232 0.00693248C7.80495 0.00997559 8.00348 0.0131119 8.20883 0.0139946C8.8926 0.0170328 10.0183 0.012877 11.2521 0.00832209C13.731 -0.000829188 16.6464 -0.0115919 17.2915 0.0311362C17.72 0.0597056 18.2255 0.216266 18.5345 0.492818C19.2282 1.11592 19.8816 1.78324 20.5348 2.45028C20.7849 2.70565 21.0349 2.96098 21.2871 3.21377ZM8.49999 10.3334C9.0527 11.4353 10.171 12 11.6184 12C13.3421 12 15 10.967 15 8.74938V2.17909H13.6053V3.19843C13.1053 2.45459 12.329 2 11.3158 2C9.4606 2 8 3.58408 8 5.55372C8 7.52347 9.4606 9.10744 11.3158 9.10744C12.329 9.10744 13.1053 8.65296 13.6053 7.90913V8.74938C13.6053 9.94769 12.8684 10.6502 11.6448 10.6502C10.5001 10.6502 10.0132 10.1819 9.72367 9.58952L8.49999 10.3334ZM11.5132 7.7163C10.3159 7.7163 9.42111 6.79348 9.42111 5.55372C9.42111 4.31407 10.3159 3.39125 11.5132 3.39125C12.7105 3.39125 13.6053 4.31407 13.6053 5.55372C13.6053 6.79348 12.7105 7.7163 11.5132 7.7163Z"
            fill="currentColor"
            key="0"
        />,
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.00054 8.24043C2.00036 8.24063 2.00018 8.24083 2 8.24102V8.23987C2.00018 8.24005 2.00036 8.24024 2.00054 8.24043ZM8.03214 6.05575C7.86122 6.05636 7.692 5.97591 7.5371 5.81985C7.3274 5.60889 7.12087 5.39519 6.91424 5.18139C6.82033 5.08422 6.72639 4.98702 6.63213 4.89005C6.22433 4.47089 5.8791 4.42689 5.40874 4.79511C4.99535 5.11816 4.58644 5.45743 4.2211 5.83722C3.67949 6.39936 3.15335 6.97694 2.62709 7.55465C2.41858 7.78354 2.21006 8.01245 2.00054 8.24043C3.01741 9.29815 4.03477 10.3554 5.05196 11.4124C5.56125 11.9416 6.0705 12.4708 6.57962 13C6.65708 12.9498 6.73769 12.903 6.8183 12.8563C6.99232 12.7554 7.16641 12.6544 7.30919 12.5183C7.85145 12.0023 8.36201 11.4514 8.8697 10.8972C8.72756 10.7283 8.6038 10.5403 8.49999 10.3334L9.72367 9.58952C9.7639 9.67182 9.80794 9.75173 9.85703 9.82833C10.1124 9.55843 10.3717 9.29271 10.6383 9.035C9.26763 8.73666 8.22508 7.54817 8.03214 6.05575ZM9.47215 5.05309C9.95393 4.65606 10.4292 4.2512 10.881 3.82015C11.027 3.68114 11.1719 3.54095 11.3159 3.39975C11.3806 3.39413 11.4464 3.39126 11.5132 3.39126C12.7105 3.39126 13.6053 4.31407 13.6053 5.55372C13.6053 6.79348 12.7105 7.7163 11.5132 7.7163C10.3159 7.7163 9.42111 6.79348 9.42111 5.55372C9.42111 5.38007 9.43867 5.21264 9.47215 5.05309ZM12.472 2.23177C12.9052 1.78323 13.3338 1.32977 13.7622 0.876629C13.7917 0.84541 13.8212 0.814192 13.8507 0.782977C13.9821 0.643602 14.0697 0.459275 14.1572 0.274814C14.1977 0.189561 14.2382 0.104279 14.2831 0.0233929C14.5528 0.0220697 14.8228 0.016966 15.0928 0.0118621C15.7679 -0.000898749 16.443 -0.0136612 17.1142 0.0326561C17.5309 0.0616037 18.0225 0.219078 18.3231 0.500449C18.9914 1.12509 19.6208 1.79489 20.2501 2.46474C20.4993 2.72989 20.7484 2.99505 21 3.25741C20.6083 3.66141 20.2171 4.06586 19.8258 4.4703C18.8087 5.52179 17.7915 6.57328 16.7667 7.61691C16.4728 7.91642 16.1631 8.19824 15.8531 8.48037C15.6741 8.64326 15.495 8.80625 15.3188 8.97282C15.1993 9.08596 15.0855 9.16848 14.9749 9.20912C14.9914 9.06195 15 8.90872 15 8.74938V2.17909H13.6053V3.19843C13.3169 2.76942 12.9366 2.43663 12.472 2.23177Z"
            fill="black"
            fillOpacity="0.2"
            key="1"
        />,
    ],
});

export const LooksRareIcon = createIcon({
    displayName: "LooksRare Icon",
    viewBox: "0 0 22 16",
    path: [
        <mask
            id="mask0_4_20877"
            // style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="22"
            height="16"
            key="0"
        >
            <path fillRule="evenodd" clipRule="evenodd" d="M0 0H22V16H0V0Z" fill="white" />
        </mask>,
        <g mask="url(#mask0_4_20877)" key="1">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.0557 10.0455C12.5596 10.0063 14.0323 9.65111 15.2466 8.72464C16.2368 7.96921 17.1227 7.10127 18.0701 6.29817C18.3309 6.07719 18.2864 5.93811 18.0547 5.73425C17.3688 5.13098 16.6938 4.51712 16.0297 3.89399C15.3732 3.27784 14.6259 2.78621 13.7485 2.47192C11.3021 1.59553 8.94302 1.7775 6.83069 3.20098C5.71044 3.95588 4.78039 4.94411 3.75944 5.82211C3.57232 5.98308 3.67288 6.08377 3.80644 6.2046C4.50907 6.84015 5.2042 7.48247 5.90919 8.11581C7.3163 9.37986 9.01448 10.0105 11.0557 10.0455ZM22.0001 6.09176C21.8647 6.20413 21.7243 6.31186 21.5949 6.4296C18.1854 9.53223 14.7772 12.6359 11.3686 15.7393C10.9864 16.0872 10.9858 16.0872 10.6016 15.7375C7.16713 12.6104 3.73262 9.48337 0.298339 6.3561C-0.100642 5.99281 -0.100568 5.99181 0.305337 5.62221C2.25162 3.84975 4.20085 2.07991 6.14109 0.301941C6.36349 0.0981468 6.59054 -0.00106539 6.91261 8.62597e-06C9.60418 0.00933914 12.2958 0.00920488 14.9873 0.000210004C15.3077 -0.000864012 15.5371 0.0929781 15.7607 0.297914C17.7092 2.08407 19.6669 3.86197 21.6229 5.64128C21.7438 5.75123 21.8741 5.85266 22.0001 5.95804V6.09176Z"
                fill="currentColor"
                key="0"
            />
        </g>,
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.4625 6.92885C12.3234 6.93642 12.9587 6.3233 12.9563 5.48703C12.9541 4.69135 12.3219 4.05923 11.5204 4.05114C10.6915 4.04283 10.0391 4.65914 10.0207 5.46796C10.0024 6.26823 10.6473 6.92165 11.4625 6.92885ZM8.00008 5.47946C7.98762 3.55831 9.49981 2.01705 11.4922 2.00013C13.4988 1.98306 15.0144 3.66109 14.9999 5.51716C14.9851 7.41789 13.3978 9.00435 11.494 8.99997C9.56085 8.99552 7.99888 7.4216 8.00008 5.47946Z"
            fill="currentColor"
            key="2"
        />,
    ],
});

export const X2Y2Icon = createIcon({
    displayName: "x2y2 Icon",
    viewBox: "0 0 20 20",
    path: [
        <path
            key="0"
            d="M18 3.92004C16.4626 2.42277 14.3595 1.5 12.0401 1.5C7.33 1.5 3.5117 5.30559 3.5117 10C3.5117 14.6944 7.33 18.5 12.0401 18.5C14.3594 18.5 16.4626 17.5772 18 16.08C16.1661 18.4633 13.2798 20 10.0334 20C4.49211 20 0 15.5229 0 10C0 4.47715 4.49211 0 10.0334 0C13.2798 0 16.1661 1.53668 18 3.92004Z"
            fill="currentColor"
        />,
        <path
            key="1"
            d="M6 14.864C7.19579 16.0618 8.83154 16.8 10.6355 16.8C14.2989 16.8 17.2687 13.7555 17.2687 10C17.2687 6.24445 14.2989 3.2 10.6355 3.2C8.83154 3.2 7.19579 3.9382 6 5.13602C7.42636 3.22934 9.67124 2 12.1962 2C16.5061 2 20 5.58172 20 10C20 14.4183 16.5061 18 12.1962 18C9.67124 18 7.42636 16.7707 6 14.864Z"
            fill="currentColor"
        />,
        <path
            key="2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10ZM14 10C14 12.2091 12.2091 14 10 14C7.79086 14 6 12.2091 6 10C6 7.79086 7.79086 6 10 6C12.2091 6 14 7.79086 14 10Z"
            fill="currentColor"
        />,
    ],
});

export const BrLightbulbOnIcon = createIcon({
    displayName: "Beyond Rarity Lightbulb On Icon",
    viewBox: "0 0 254.35 290.91",
    path: [
        <path
            key="0"
            d="M127.45,230.17c-11.32,0-22.65,.03-33.97-.01-6.85-.02-10.34-2.88-9.72-9.62,1.75-19.17-5.61-34.64-16.87-49.61-34.15-45.43-4.95-112.1,51.72-119.05,41.7-5.11,79.87,25.16,84.43,66.79,2.26,20.63-3.52,38.8-16.13,54.97-9.7,12.44-16.13,25.95-14.81,42.24,.15,1.82,.07,3.66-.01,5.49-.28,5.88-3.19,8.75-9.17,8.78-11.82,.07-23.65,.02-35.47,.02Zm33-12.13c0-4.74-.36-9.22,.07-13.63,1.44-14.78,8.4-27.17,17.41-38.58,8.75-11.08,13.58-23.72,13.79-37.77,.61-40.06-36.11-71-75.51-63.92-35.09,6.3-58.96,43.16-50.27,77.7,2.52,10.02,7.63,18.65,13.94,26.79,10.27,13.24,16.59,28.02,15.65,45.23-.08,1.4,.22,2.83,.33,4.18h64.58Z"
            fill="currentColor"
        />,
        ,
        <path
            key="1"
            d="M160.27,271.45c-10.03,16.66-31.5,24.2-47.83,16.36-6.16-2.96-10.84-9.07-16.03-13.91-.31-.29,.57-2.37,1.37-3.13,.54-.51,1.9-.18,2.89-.18,17.98-.02,35.95-.05,53.93,0,1.69,0,3.37,.5,5.67,.87Z"
            fill="currentColor"
        />,
        ,
        <path
            key="2"
            d="M128.37,235.93c10.32,0,20.65-.03,30.97,.01,4.95,.02,7.74,2.2,7.41,5.98-.38,4.31-3.28,5.83-7.28,5.83-21.15,0-42.3,.03-63.45-.02-5-.01-7.46-2.18-7.28-6.17,.21-4.56,3.14-5.71,7.15-5.69,10.82,.07,21.65,.02,32.47,.02v.02Z"
            fill="currentColor"
        />,
        ,
        <path
            key="3"
            d="M127.55,265.07c-10.5,0-21,.03-31.49-.01-5.07-.02-7.47-2.02-7.29-6.08,.2-4.48,3.07-5.86,7.09-5.86,21.16,.01,42.33-.02,63.49,.02,4.79,0,7.7,2.38,7.39,6.13-.35,4.28-3.07,5.86-7.19,5.83-10.66-.08-21.33-.03-31.99-.03Z"
            fill="currentColor"
        />,
        ,
        <path
            key="4"
            d="M181.62,187.22c2.73-2.42,5.45-4.82,8.55-7.56,9.21,9.24,19.09,19.02,28.81,28.98,2.27,2.33,1.98,5.37-.21,7.67-2.37,2.49-5.58,2.85-8.04,.42-9.79-9.68-19.35-19.58-29.12-29.52Z"
            fill="currentColor"
        />,
        ,
        <path
            key="5"
            d="M133.84,46.93h-11.61c-.11-1.53-.31-2.96-.31-4.39-.02-11.66-.04-23.33,0-34.99C121.94,2.52,123.98,.02,127.86,0c3.86-.02,5.94,2.52,5.96,7.54,.04,12.96,.01,25.93,.01,39.4Z"
            fill="currentColor"
        />,
        ,
        <path
            key="6"
            d="M76.73,67.07c-3.19,2.84-5.89,5.25-8.86,7.9-9.51-9.5-19.32-19.16-28.95-29-2.4-2.46-2.27-5.57,.21-8.04,2.7-2.68,5.74-2.48,8.39,.13,9.59,9.44,19.1,18.96,29.2,29.02Z"
            fill="currentColor"
        />,
        ,
        <path
            key="7"
            d="M187.77,75.63c-3.11-3.12-5.56-5.58-8.21-8.24,.43-.68,.74-1.44,1.27-1.98,8.79-8.85,17.65-17.64,26.42-26.51,2.82-2.85,5.8-4.02,9.19-1.22,2.91,2.41,2.64,6.15-.73,9.6-9.16,9.39-18.41,18.69-27.94,28.35Z"
            fill="currentColor"
        />,
        ,
        <path
            key="8"
            d="M65.13,179.84c3.34,3.11,5.87,5.48,9.49,8.86-2.8,2.58-5.83,5.12-8.57,7.94-6.49,6.68-12.85,13.49-19.24,20.26-2.79,2.95-6.1,4-9.17,1.05-3-2.88-2.33-6.21,.51-9.22,9.11-9.68,18.16-19.42,26.98-28.88Z"
            fill="currentColor"
        />,
        ,
        <path
            key="9"
            d="M46.93,120.89v11.88c-5.33,0-10.43,0-15.54,0-7.98,0-15.96,.1-23.93-.03-4.69-.07-7.83-2.73-7.41-6.26,.49-4.22,3.26-5.67,7.37-5.63,13.08,.11,26.17,.04,39.52,.04Z"
            fill="currentColor"
        />,
        ,
        <path
            key="10"
            d="M207.98,120.94c13.87,0,27.62-.19,41.35,.22,1.83,.05,4.79,3.01,5.01,4.88,.22,1.88-2.24,4.15-3.74,6.1-.39,.51-1.55,.58-2.35,.58-13.27,.03-26.54,.02-40.27,.02v-11.8Z"
            fill="currentColor"
        />,
        ,
        <path
            key="11"
            d="M121.86,73.25c.98,.25,1.91,.7,2.73,1.41,3.93,3.41,.55,8.35-3.29,9.93-3,1.23-6.33,1.66-9.37,2.92-5.95,2.46-11.19,6.37-15.14,11.46-1.24,1.6-2.36,3.31-3.35,5.08-2.12,3.8-4.87,5.49-8.97,3.6-3.25-1.5-3.77-5.38-1.37-9.58,7.16-12.55,18.72-19.92,32.19-24.28,2.08-.67,4.44-1.07,6.56-.53Z"
            fill="currentColor"
        />,
    ],
});

export const BrRocketIcon = createIcon({
    displayName: "Beyond Rarity Rocket",
    viewBox: "0 0 36.62 36.62",
    path: [
        <defs key="0">
            <style>{`.cls-1{fill:url(#linear-gradient);opacity:.9;}.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}`}</style>
            <linearGradient
                id="linear-gradient"
                x1="19.69"
                y1="15.05"
                x2="23.45"
                y2="15.05"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#f16844" />
                <stop offset="1" stopColor="#ea3a65" />
            </linearGradient>
        </defs>,
        <path
            key="1"
            className="cls-2"
            d="M8.05,21.16l1-2.24C17.21,.87,35.62,1,35.62,1c0,0,.11,15.49-13.8,24.35-1.25,.8-2.62,1.54-4.11,2.22l-2.24,1"
        />,
        <path
            key="2"
            className="cls-2"
            d="M11.6,14.29C3.65,14.29,1.82,23.29,1.82,23.29h.88c2.82,0,5.52,1.12,7.52,3.11h0c1.99,1.99,3.11,4.7,3.11,7.52v.88s9-1.83,9-9.78"
        />,
        <path
            key="3"
            className="cls-2"
            d="M24.2,17.68c-1.45,1.45-3.81,1.45-5.26,0-1.45-1.45-1.45-3.81,0-5.26s3.81-1.45,5.26,0c1.45,1.45,1.45,3.81,0,5.26Z"
        />,
        <path
            key="4"
            className="cls-1"
            d="M21.57,16.93c-.5,0-.97-.2-1.33-.55-.73-.73-.73-1.93,0-2.66,.36-.36,.83-.55,1.33-.55s.97,.2,1.33,.55c.36,.36,.55,.83,.55,1.33s-.2,.97-.55,1.33c-.36,.36-.83,.55-1.33,.55Z"
        />,
        <path
            key="5"
            className="cls-2"
            d="M34.1,9.16c-1.64-.2-3.22-.92-4.47-2.17s-1.97-2.83-2.17-4.47"
        />,
        <path
            key="6"
            className="cls-2"
            d="M4.91,27.17C.04,32.07,1.1,35.52,1.1,35.52c0,0,3.45,1.06,8.35-3.81"
        />,
        <line key="7" className="cls-2" x1="8.67" y1="27.97" x2="5.89" y2="30.75" />,
    ],
});

export const GraduationIcon = createIcon({
    displayName: "Graduation Hat",
    viewBox: "0 0 700 624.23",
    path: [
        <g key="1">
            <path
                d="M356.25 440.25a56.58 56.58 0 0 1-28.25-7.56L20.06 254.82a40 40 0 0 1 0-69.41L328.2 7.51a56.62 56.62 0 0 1 56.32 0L641.68 156a25.29 25.29 0 0 1 9.45 34.25 3.24 3.24 0 0 1-.17.32A25.31 25.31 0 0 1 616.7 200l-.32-.18L359.31 51.39a5.83 5.83 0 0 0-5.81 0L60 220.87l293.61 168a5.52 5.52 0 0 0 5.59 0l300.11-173.25a25.37 25.37 0 0 1 38 21.78v160a25.35 25.35 0 0 1-50.7 0V281.32l-262 151.31a56.32 56.32 0 0 1-28.19 7.62Z"
                fill="currentColor"
            />
            <path
                d="M356.38 615.77a57.68 57.68 0 0 1-28.85-7.77L124.67 490.94a52.37 52.37 0 0 1-26-45.08v-81a25.35 25.35 0 0 1 50.7 0v81a1.35 1.35 0 0 0 .67 1.22l202.84 117.11a7.22 7.22 0 0 0 7.16 0l202.82-117.13a1.44 1.44 0 0 0 .71-1.24v-81a25.35 25.35 0 0 1 50.7 0v81a52.39 52.39 0 0 1-26 45.07L385.4 608.05a57.69 57.69 0 0 1-28.82 7.72Z"
                fill="currentColor"
            />
        </g>,
    ],
});

export const LinkIcon = createIcon({
    displayName: "Link",
    viewBox: "0 0 261.24 259.78",
    path: [
        <g key="1">
            <g>
                <path
                    fill="currentColor"
                    d="M179.5,148.48c-.34,18.92-6.69,34.87-19.45,47.91-14.56,14.88-29.23,29.7-44.53,43.81-28.78,26.55-68.66,26.24-95.89-1.86-26.16-27-25.91-65.26-.84-93.4,4.54-5.09,9.56-9.77,14.47-14.52,6.1-5.91,14.7-6.07,20.68-.52,6.2,5.75,6.75,14.42,.92,20.96-4.43,4.97-9.35,9.5-14.04,14.24-15.12,15.25-14.4,39.31,1.59,53.74,16.49,14.87,37.24,14.69,53.06-.68,14.45-14.04,28.81-28.19,43.08-42.41,14.98-14.92,15.11-37.43,.47-52.83-6.51-6.85-6.66-16.29-.36-22.22,6.14-5.78,15.53-5.29,21.82,1.48,12.26,13.2,18.65,28.87,19.03,46.32Z"
                />
                <path
                    fill="currentColor"
                    d="M261.24,68.11c-.87,18.1-7.06,34.04-19.52,47.35-4.32,4.62-8.88,9.03-13.42,13.45-6.47,6.3-15.31,6.37-21.38,.26-6.17-6.22-6.09-14.81,.25-21.35,5.33-5.51,11.03-10.68,15.99-16.5,9.34-10.96,11.13-29.24,3.51-41.19-9.24-14.5-21.13-21.77-38.36-19.97-9.07,.95-16.33,4.96-22.64,11.35-13.82,13.99-27.8,27.82-41.68,41.75-15.58,15.62-15.91,37.56-.83,53.54,6.48,6.87,6.66,15.73,.44,21.81-6.19,6.06-15.35,5.92-21.76-.96-25.58-27.48-26.08-66.36-.14-94.2,13.85-14.87,28.24-29.27,42.99-43.24,28.72-27.18,68.68-26.91,96.77,.62,12.96,12.71,18.82,29.12,19.77,47.28Z"
                />
            </g>
        </g>,
    ],
});

export const EditIcon = createIcon({
    displayName: "Edit",
    viewBox: "0 0 18 18",
    path: [
        <defs key="edit1">
            <clipPath id="a">
                <rect width="18" height="18" fill="#e93766" />
            </clipPath>
        </defs>,
        <g clipPath="url(#a)" key="edit2">
            <path
                d="M.006,8.849c0-1.5-.017-3.01,0-4.514A4.032,4.032,0,0,1,4.28.022a18.516,18.516,0,0,1,2.34.03c.288.031.542.379.812.583-.268.2-.52.549-.806.579-.772.083-1.559.018-2.34.036A2.905,2.905,0,0,0,1.24,4.322q-.033,4.6,0,9.2a2.874,2.874,0,0,0,3,3.021q4.642.044,9.284,0a2.9,2.9,0,0,0,3-3.027c.02-.781-.046-1.568.035-2.341.03-.29.366-.549.563-.822.208.264.581.519.6.793a22.231,22.231,0,0,1-.028,3.207,3.814,3.814,0,0,1-3.454,3.361q-5.332.122-10.669,0A3.8,3.8,0,0,1,.054,14.143C-.025,12.382.037,10.614.037,8.849H.006"
                transform="translate(0 0)"
                fill="#e93766"
            />
            <path
                d="M42.973,3.725V3.73a1.553,1.553,0,0,1-.094.3A6.07,6.07,0,0,1,41.411,5.99q-1,1.024-2.015,2.039-2,2.007-4.047,3.972a4.124,4.124,0,0,1-1.548.688c-.738.249-1.49.463-2.247.643s-1.107-.185-.908-.957c.26-1.006.536-2.009.838-3a1.834,1.834,0,0,1,.432-.732q2-2.02,4.012-4.032Q36.933,3.6,37.942,2.6a4.873,4.873,0,0,1,1.844-1.465,2.573,2.573,0,0,1,1.719.128,2.472,2.472,0,0,1,1.468,2.461m-8.347,7.042c2.281-2.247,4.521-4.408,6.681-6.648.225-.233.128-1.029-.1-1.386-.329-.519-.943-.464-1.466-.126a2.08,2.08,0,0,0-.322.288q-2.943,2.942-5.882,5.889a4.232,4.232,0,0,0-.35.458l1.438,1.524m-2.149-.3c-.134.542-.217.873-.335,1.352l1.35-.38-1.015-.971"
                transform="translate(-25.283 -0.861)"
                fill="#e93766"
            />
        </g>,
    ],
});

export const BRLogo = createIcon({
    displayName: "BRLogo",
    viewBox: "0 0 64.6 52",
    path: [
        <path
            key="BRL1"
            fill="currentColor"
            d="M45.9 11.7h18.5L52.7 0H34.2a11.72 11.72 0 0 0 11.7 11.7ZM30.4 0H11.9L.2 11.7h18.5A11.72 11.72 0 0 0 30.4 0Zm15.4 15.4A11.66 11.66 0 0 0 34.1 27v25l30.5-36.5H45.8Zm-27 0H0l30.5 36.5V27.1a11.78 11.78 0 0 0-11.7-11.7Z"
        />,
    ],
});

export const BRLogoStacked = createIcon({
    displayName: "BRLogoStacked",
    viewBox: "0 0 330 63",
    path: [
        <defs key="brs0">
            <radialGradient
                id="a"
                cx="0"
                cy="0"
                r="1"
                gradientTransform="matrix(29.2656 0 0 29.2716 -19.618 13.338)"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FA9B1E" />
                <stop offset="1" stopColor="#E1058C" />
            </radialGradient>
        </defs>,
        <path
            key="brs1"
            fill="#282D41"
            d="M210.5 37.9h-7.2V63h7.2V37.9Zm70.8 0-10.9 9.7-10.9-9.7h-44.3v6.2h16.1V63h7.2V44.1h18.6l9.7 9V63h7.2v-9.9l17-15.2h-9.7Zm-137.3 0h-15.5L115.1 63h7.8l9.9-18.9h6.9l10 18.9h7.7L144 37.9ZM112.8 46a8.075 8.075 0 0 0-4.995-7.493 8.066 8.066 0 0 0-3.105-.607H74.8a6.273 6.273 0 0 0 6.3 6.3h23.2a1.802 1.802 0 0 1 1.273 3.073 1.802 1.802 0 0 1-1.273.527H81.1a6.273 6.273 0 0 0-6.3 6.3V63h7v-8.9h16.3l5.3 8.9h8.3l-5.9-9a8.174 8.174 0 0 0 7-8Zm86 0a8.075 8.075 0 0 0-4.995-7.493 8.066 8.066 0 0 0-3.105-.607h-29.9a6.272 6.272 0 0 0 3.885 5.827 6.276 6.276 0 0 0 2.415.473h23.2a1.802 1.802 0 0 1 1.273 3.073 1.802 1.802 0 0 1-1.273.527h-23.2a6.274 6.274 0 0 0-6.3 6.3V63h7v-8.9h16.3l5.3 8.9h8.3l-5.9-9a8.174 8.174 0 0 0 7-8Zm-46.2-21.7h-28v-3.7h25.5v-5.2h-25.5v-3.7h28V5.4h-35.2v25.2h35.2v-6.3Zm35.6-18.9-10.9 9.1-10.9-9.1h-9.7l17 14.5v10.7h7.2V20L198 5.4h-9.8Zm56.3 0v25.2h7.1V13.8l25.6 16.8h7.4V5.4h-7v16.8L251.9 5.4h-7.4ZM226.7 5h-14.9c-8.1 0-13.8 5.3-13.8 13s5.7 13 13.8 13h14.9c8.1 0 13.8-5.3 13.8-13s-5.7-13-13.8-13Zm0 19.3h-14.9a6.264 6.264 0 0 1-4.597-1.76A6.265 6.265 0 0 1 205.3 18a6.147 6.147 0 0 1 6.5-6.3h14.9a6.301 6.301 0 0 1 0 12.6Zm88.6-18.9h-25.9v25.1h25.9c8.3 0 13.9-5 13.9-12.6-.1-7.4-5.6-12.5-13.9-12.5Zm0 18.9h-18.7V11.7h18.7a6.264 6.264 0 0 1 4.597 1.76A6.265 6.265 0 0 1 321.8 18c0 3.6-2.7 6.2-6.5 6.3ZM113.4 13a7.601 7.601 0 0 0-7.6-7.6H74.2v25.1h31.6a7.58 7.58 0 0 0 5.7-12.6 6.963 6.963 0 0 0 1.9-4.9Zm-9.1 11.3h-23v-3.7h23a1.79 1.79 0 0 1 1.8 1.8 1.878 1.878 0 0 1-1.8 1.9Zm0-8.9h-23v-3.7h23a1.792 1.792 0 0 1 1.8 1.8 1.878 1.878 0 0 1-1.8 1.9Z"
        />,
        <path
            key="brs2"
            fill="url(#a)"
            d="M30.5 0H12L.3 11.7h18.5A11.715 11.715 0 0 0 30.5 0ZM46 11.7h18.5L52.8 0H34.3A11.65 11.65 0 0 0 46 11.7Zm-.1 3.7a11.65 11.65 0 0 0-11.7 11.7v24.8l30.5-36.5H45.9Zm-27.1 0H0l30.5 36.5V27.1a11.65 11.65 0 0 0-11.7-11.7Z"
        />,
    ],
});

export const GoogleLogo = createIcon({
    displayName: "GoogleLogo",
    viewBox: "0 0 24 24",
    path: [
        <path
            key="g1"
            fill="#4285F4"
            d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        />,
        <path
            key="g2"
            fill="#34A853"
            d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        />,
        <path
            key="g3"
            fill="#FBBC05"
            d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        />,
        <path
            key="g4"
            fill="#EA4335"
            d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        />,
        <path key="g5" fill="none" d="M1 1h22v22H1z" />,
    ],
});

export const WalletConnectIcon = createIcon({
    displayName: "WalletConnectIcon",
    viewBox: "0 0 22 16",
    path: [
        <defs key="wc1">
            <clipPath id="wc1">
                <path fill="currentColor" d="M0 0h22v15.946H0z" />
            </clipPath>
        </defs>,
        <g key="wc2" fill="currentColor" clipPath="url(#wc1)">
            <path d="M17.451 7.244a.729.729 0 1 1-.729.729.729.729 0 0 1 .729-.729" />
            <path d="M20.439 5.028H19.5V2.005A2.007 2.007 0 0 0 17.5 0H2.005A2.007 2.007 0 0 0 0 2.005v11.936a2.007 2.007 0 0 0 2.005 2.005H17.5a2.007 2.007 0 0 0 2-2.005v-3.026h.937A1.563 1.563 0 0 0 22 9.354V6.587a1.563 1.563 0 0 0-1.561-1.559M1.107 13.941V2.005a.9.9 0 0 1 .9-.9h2.24V14.84H2.005a.9.9 0 0 1-.9-.9Zm17.29 0a.9.9 0 0 1-.9.9H5.351V1.107H17.5a.9.9 0 0 1 .9.9v3.021h-1.489a2.945 2.945 0 1 0 0 5.89h1.483Zm2.5-4.584a.455.455 0 0 1-.455.454h-3.529a1.838 1.838 0 1 1-.086-3.675h3.614a.455.455 0 0 1 .455.455Z" />
        </g>,
    ],
});
export const LightningBoltIcon = createIcon({
    displayName: "Lighting Bolt Icon",
    viewBox: "0 0 93.6 164.07",
    path: [
        <defs key="1">
            <style>{`.cls-1{fill:currentColor;}`}</style>
        </defs>,
        <g key="2">
            <path
                className="cls-1"
                d="m44.31,97.43c-14.34.05-28.2.11-42.61.16-1.29,0-2.11-1.37-1.48-2.49C15.81,67.23,42.53,19.15,52.84.86c.91-1.61,3.36-.78,3.12,1.04-2.68,20.21-5.6,41.9-8.36,62.81-.13,1.01.66,1.9,1.68,1.89,14.32-.05,28.24-.11,42.62-.16,1.29,0,2.11,1.37,1.48,2.49-15.6,27.86-42.31,75.97-52.62,94.27-.91,1.61-3.36.78-3.12-1.04,2.67-20.16,5.57-41.85,8.34-62.84.13-1.01-.66-1.9-1.68-1.89Z"
            />
        </g>,
    ],
});

export const GetGradientFlameIcon = (startColor = "#f47a5a", endColor = "#e93d66") => {
    return createIcon({
        displayName: "Gradient Flame Icon",
        viewBox: "0 0 246.04 380.56",
        path: [
            <defs key="1">
                <linearGradient
                    id="New_Gradient_Swatch_1"
                    x1="123.02"
                    y1="-.57"
                    x2="123.02"
                    y2="382.03"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color={startColor} />
                    <stop offset="1" stop-color={endColor} />
                </linearGradient>
            </defs>,
            <g key="2">
                <path
                    fill="url(#New_Gradient_Swatch_1)"
                    d="m101.25,0c9.14,7.07,18.86,13.5,27.31,21.32,37.87,35.05,53.54,78.88,49.84,129.96-.98,13.59-2.42,27.15-3.64,40.67,14.52-2.34,26.87-24.27,29.32-52.58.44.12,1.03.1,1.24.37,17.13,22,31.3,45.5,37.68,73.08,7.66,33.1.42,63.37-17.01,91.78-18.47,30.09-43.4,54.14-71.4,75.39,1.63-1.91,3.41-3.72,4.87-5.75,6.97-9.72,14.82-18.96,20.58-29.35,16.09-29.02,12.44-57.85-3.88-85.45-7.18-12.14-15.98-23.33-24.06-34.94-2.57-3.69-5.3-7.27-7.77-11.02-11.93-18.13-15.99-29-9.38-50.65-12.55,3.61-31.68,29.27-38.11,50.45-6.47,21.31-4.37,42.81-2.01,64.42-8.25-2.14-12.37-9.92-16.54-30.84-27.47,36.27-36.93,81.47,12.53,133.7-3.6-2.91-7.27-5.76-10.8-8.75-22.33-18.94-42.51-39.79-58.45-64.58-28.16-43.8-28.08-88.2-3.62-133.36,11.42-21.08,26.66-39.37,41.63-57.91,11.6-14.37,23.18-28.82,33.76-43.93,15.04-21.47,18.01-44.7,7.12-69.11-.2-.44-.27-.93-.4-1.4.4-.51.79-1.01,1.19-1.52Z"
                />
            </g>,
        ],
    });
};

type OwnedDiamondIconType = {
    borderColor?: string;
    strokeWidth?: number;
    startFillColor?: string;
    endFillColor?: string;
};

export const GetOwnedDiamondIcon = ({
    borderColor = chakraTheme.colors.chart.datapoint.owned.pointBorder,
    strokeWidth = 15,
    startFillColor = chakraTheme.colors.chart.datapoint.owned.from,
    endFillColor = chakraTheme.colors.chart.datapoint.owned.to,
}: OwnedDiamondIconType) => {
    const halfStrokeWidth = strokeWidth / 2;
    return createIcon({
        displayName: "Owned Diamond",
        viewBox: `${-halfStrokeWidth} ${-halfStrokeWidth} ${120 + strokeWidth} ${
            150 + strokeWidth
        }`,
        defaultProps: {
            width: "24px",
            height: "50px",
        },
        path: [
            <defs key={1} id="defs1">
                <linearGradient
                    id="lg1"
                    x1="124.14399"
                    y1="-22.471243"
                    x2="224.14398"
                    y2="77.528755"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(0.92647095,0,0,0.92647095,17.867774,-14.945166)"
                >
                    <stop style={{ stopColor: startFillColor }} offset="0" id="stop1" />
                    <stop style={{ stopColor: endFillColor }} offset="1" id="stop2" />
                </linearGradient>
            </defs>,
            <g key="2" id="layer1" transform="translate(-45.088118,-73.19724)">
                <rect
                    style={{
                        mixBlendMode: "normal",
                        fill: "url(#lg1)",
                        fillOpacity: 1,
                        stroke: borderColor,
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                    }}
                    id="rect845"
                    width={"92.647087"}
                    height={"92.647087"}
                    x="132.88358"
                    y="-35.764122"
                    transform="matrix(0.62259968,0.7825405,-0.62259968,0.7825405,0,0)"
                />
            </g>,
        ],
    });
};
